export const homePageCopy = {
  English: {
    heroTagline: 'Flow into your energy',
    heroPrimary: 'Explore Services',
    heroSecondary: 'Book a Session',
    intro: {
      title: 'Welcome to ManaWave',
      text: 'ManaWave is a sanctuary for energy healing and spiritual wellness. Through the ancient practice of Reiki and universal energy work, we guide you toward balance, healing, and alignment. Experience the gentle flow of energy that connects mind, body, and spirit, creating harmony within and around you.'
    },
    reiki: {
      title: 'What Is Reiki & Universal Energy',
      text: 'Reiki is a Japanese healing technique that channels universal life force energy through gentle touch or intention. This energy flows naturally through all living things, promoting physical, emotional, and spiritual healing. At ManaWave, we work with this universal energy to help restore balance, release blockages, and support your natural healing process.'
    },
    howItWorks: {
      title: 'How It Works',
      steps: [
        { title: 'Choose a Service', description: 'Select from our range of energy healing sessions tailored to your needs.' },
        { title: 'Book in Advance', description: 'Schedule your session at a time that works best for your journey.' },
        { title: 'Energy Work', description: 'Receive healing energy remotely or through guided on-call sessions.' },
        { title: 'Integration & Support', description: 'Continue your healing journey with ongoing guidance and support.' }
      ]
    },
    services: {
      title: 'Our Services',
      loading: 'Loading services...',
      empty: 'No services available at the moment.',
      viewAll: 'View All Services'
    },
    benefits: {
      title: 'Why Try Energy Work',
      items: [
        { title: 'Emotional Balance', text: 'Release emotional blockages and find inner peace through gentle energy healing.' },
        { title: 'Mental Clarity', text: 'Clear mental fog and enhance focus with balanced energy flow throughout your being.' },
        { title: 'Spiritual Alignment', text: 'Connect with your higher self and align with your true purpose and path.' },
        { title: 'Physical Wellbeing', text: "Support your body's natural healing processes and promote overall wellness." }
      ]
    },
    sessions: {
      title: 'Guided & Remote Sessions',
      cards: [
        {
          title: 'Remote Energy Sessions',
          description: 'Receive healing energy from anywhere in the world. Our practitioners channel universal energy to you remotely, creating a powerful connection that transcends physical distance. Perfect for those seeking flexibility and comfort.',
          image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&q=80',
          alt: 'Remote energy healing'
        },
        {
          title: 'On-Call Guided Sessions',
          description: 'Experience personalized guidance during your session. Connect via phone or video call as our practitioners guide you through the healing process, offering real-time support and insights.',
          image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80',
          alt: 'Guided healing session'
        }
      ]
    },
    testimonials: {
      title: 'Energy Experiences',
      items: [
        { text: '"A transformative experience that brought deep peace and clarity."', author: '— Coming Soon' },
        { text: '"The energy flow was gentle yet powerful, leaving me feeling renewed."', author: '— Coming Soon' },
        { text: '"ManaWave helped me find balance I didn\'t know I was missing."', author: '— Coming Soon' }
      ]
    },
    cta: {
      title: 'Begin Your Journey',
      text: 'Take the first step toward balance, healing, and alignment. Your energy journey awaits.',
      button: 'Start Your Session'
    },
    partners: {
      title: 'Our Partners'
    }
  },
  Arabic: {
    heroTagline: 'انطلق في طاقتك',
    heroPrimary: 'استكشف الخدمات',
    heroSecondary: 'احجز جلسة',
    intro: {
      title: 'مرحباً بكم في ماناويف',
      text: 'ماناويف هو ملاذ للشفاء الطاقي والرفاهية الروحية. من خلال ممارسة الريكي القديمة والعمل بالطاقة الكونية، نرشدك نحو التوازن والشفاء والانسجام. اختبر تدفق الطاقة اللطيف الذي يربط العقل والجسم والروح ويخلق تناغماً داخلياً وحولك.'
    },
    reiki: {
      title: 'ما هو ريكي والطاقة الكونية',
      text: 'الريكي هو تقنية يابانية للشفاء تنقل طاقة الحياة الكونية عبر اللمسات الرقيقة أو النية المركزة. تتدفق هذه الطاقة طبيعياً عبر جميع الكائنات الحية، مما يعزز الشفاء الجسدي والعاطفي والروحي. في ماناويف نعمل بهذه الطاقة الكونية لاستعادة التوازن، وإزالة العوائق، ودعم مسار الشفاء الطبيعي لديك.'
    },
    howItWorks: {
      title: 'كيف يعمل',
      steps: [
        { title: 'اختر خدمة', description: 'اختر من بين جلسات الشفاء الطاقي المصممة خصيصاً لاحتياجاتك.' },
        { title: 'احجز مقدماً', description: 'حدد موعد جلستك في الوقت الذي يناسب مسارك الروحي.' },
        { title: 'العمل الطاقي', description: 'تلقَّى الطاقة الشافية عن بعد أو من خلال جلسات موجهة عبر الاتصال.' },
        { title: 'التكامل والدعم', description: 'واصل رحلتك مع إرشاد ودعم مستمر.' }
      ]
    },
    services: {
      title: 'خدماتنا',
      loading: 'جاري تحميل الخدمات...',
      empty: 'لا توجد خدمات متاحة في الوقت الحالي.',
      viewAll: 'عرض كل الخدمات'
    },
    benefits: {
      title: 'لماذا تجربة العمل الطاقي',
      items: [
        { title: 'التوازن العاطفي', text: 'حرر العوائق العاطفية واكتشف السلام الداخلي من خلال الشفاء الطاقي اللطيف.' },
        { title: 'الوضوح الذهني', text: 'صفِّ ذهنك وعزز التركيز مع تدفق طاقة متوازن في كامل كيانك.' },
        { title: 'الاتساق الروحي', text: 'اتصل بذاتك العليا وتوافق مع هدفك الحقيقي.' },
        { title: 'الصحة الجسدية', text: 'ادعم عمليات شفاء جسدك الطبيعية وعزز عافيتك العامة.' }
      ]
    },
    sessions: {
      title: 'جلسات موجهة وعن بعد',
      cards: [
        {
          title: 'جلسات الطاقة عن بعد',
          description: 'تلقي الطاقة الشافية من أي مكان في العالم. يوجهك الممارسون عبر الطاقة الكونية عن بعد، مما يخلق اتصالاً قوياً يتجاوز المسافة المادية. مثالية لمن يبحثون عن المرونة والراحة.',
          image: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=600&q=80',
          alt: 'الطاقة عن بعد'
        },
        {
          title: 'جلسات موجهة عند الطلب',
          description: 'اختبر الإرشاد الشخصي خلال جلستك. تواصل عبر مكالمة هاتفية أو فيديو بينما يوجهك الممارسون خلال عملية الشفاء، مقدمين دعمًا ورؤى فورية.',
          image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80',
          alt: 'جلسة موجهة'
        }
      ]
    },
    testimonials: {
      title: 'تجارب الطاقة',
      items: [
        { text: '"تجربة تحولية جلبت سلامًا ووضوحًا عميقين."', author: '— قريبًا' },
        { text: '"كان تدفق الطاقة لطيفًا لكنه قوي، شعرت بالتجدد."', author: '— قريبًا' },
        { text: '"ساعدتني ماناويف في العثور على توازن لم أكن أعلم أنه مفقود."', author: '— قريباً' }
      ]
    },
    cta: {
      title: 'ابدأ رحلتك',
      text: 'اتخذ الخطوة الأولى نحو التوازن والشفاء والانسجام. رحلة طاقتك في انتظارك.',
      button: 'ابدأ جلستك'
    },
    partners: {
      title: 'شركاؤنا'
    }
  },
  Russian: {
    heroTagline: 'Погрузитесь в свою энергию',
    heroPrimary: 'Изучить услуги',
    heroSecondary: 'Записаться на сессию',
    intro: {
      title: 'Добро пожаловать в ManaWave',
      text: 'ManaWave — это убежище энергетического исцеления и духовного благополучия. Через древнюю практику Рейки и работу с универсальной энергией мы ведём вас к равновесию, исцелению и гармонии. Почувствуйте мягкий поток энергии, соединяющий разум, тело и дух, создавая гармонию внутри и вокруг вас.'
    },
    reiki: {
      title: 'Что такое Рейки и универсальная энергия',
      text: 'Рейки — японская техника исцеления, которая направляет универсальную жизненную энергию через мягкое прикосновение или намерение. Эта энергия естественно протекает через всё живое, способствуя физическому, эмоциональному и духовному исцелению. В ManaWave мы используем эту энергию, чтобы восстановить баланс, снять блокировки и поддержать ваш естественный путь исцеления.'
    },
    howItWorks: {
      title: 'Как это работает',
      steps: [
        { title: 'Выберите услугу', description: 'Выберите из нашего спектра сессий энергетического исцеления, подобранных под ваши потребности.' },
        { title: 'Запишитесь заранее', description: 'Назначьте сессию на удобное для вас время.' },
        { title: 'Энергетическая работа', description: 'Получите исцеляющую энергию удалённо или в ходе направляемых сессий по вызову.' },
        { title: 'Интеграция и поддержка', description: 'Продолжайте путь исцеления при поддержке и сопровождении.' }
      ]
    },
    services: {
      title: 'Наши услуги',
      loading: 'Загрузка услуг...',
      empty: 'В данный момент услуги отсутствуют.',
      viewAll: 'Посмотреть все услуги'
    },
    benefits: {
      title: 'Зачем пробовать энергетическую работу',
      items: [
        { title: 'Эмоциональное равновесие', text: 'Освободитесь от эмоциональных блоков и обретите внутренний покой с помощью мягкого энергетического исцеления.' },
        { title: 'Ментальная ясность', text: 'Разгрузите ум и улучшите концентрацию через сбалансированный поток энергии по всему телу.' },
        { title: 'Духовная гармония', text: 'Соединитесь с высшим «я» и синхронизируйтесь со своим истинным предназначением.' },
        { title: 'Физическое благополучие', text: 'Поддержите естественные процессы исцеления тела и укрепите общее состояние здоровья.' }
      ]
    },
    sessions: {
      title: 'Сессии с наставником и удалённые',
      cards: [
        {
          title: 'Удалённые энергетические сессии',
          description: 'Получайте исцеляющую энергию из любой точки мира. Наши практики направляют универсальную энергию к вам дистанционно, создавая мощную связь, которая превосходит физическое расстояние. Идеально для тех, кто ценит гибкость и комфорт.',
          image: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=600&q=80',
          alt: 'Удалённое энергетическое исцеление'
        },
        {
          title: 'Сессии с персональным сопровождением',
          description: 'Получите персональные советы во время сессии. Общайтесь по телефону или видеосвязи, пока практики ведут вас через процесс исцеления, предоставляя поддержку и подсказки в реальном времени.',
          image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80',
          alt: 'Сессия с наставником'
        }
      ]
    },
    testimonials: {
      title: 'Энергетические впечатления',
      items: [
        { text: '"Преобразующий опыт, который принес глубокий покой и ясность."', author: '— Скоро' },
        { text: '"Энергия была мягкой, но мощной, я почувствовал себя обновлённым."', author: '— Скоро' },
        { text: '"ManaWave помог найти баланс, о существовании которого я даже не догадывался."', author: '— Скоро' }
      ]
    },
    cta: {
      title: 'Начните ваше путешествие',
      text: 'Сделайте первый шаг к равновесию, исцелению и гармонии. Ваша энергия ждёт вас.',
      button: 'Начать сессию'
    },
    partners: {
      title: 'Наши партнёры'
    }
  },
  German: {
    heroTagline: 'Fließe in deine Energie',
    heroPrimary: 'Dienste erkunden',
    heroSecondary: 'Sitzung buchen',
    intro: {
      title: 'Willkommen bei ManaWave',
      text: 'ManaWave ist ein Zufluchtsort für Energieheilung und spirituelles Wohlbefinden. Durch die uralte Praxis des Reiki und universeller Energiearbeit führen wir dich zu Balance, Heilung und Ausrichtung. Erlebe den sanften Energiefluss, der Geist, Körper und Seele verbindet und Harmonie in dir und um dich herum schafft.'
    },
    reiki: {
      title: 'Was ist Reiki & Universelle Energie',
      text: 'Reiki ist eine japanische Heilmethode, die universelle Lebensenergie durch sanfte Berührung oder Intention kanalisiert. Diese Energie fließt natürlich durch alle Lebewesen und fördert körperliche, emotionale und spirituelle Heilung. Bei ManaWave arbeiten wir mit dieser universellen Energie, um Balance wiederherzustellen, Blockaden zu lösen und deinen natürlichen Heilungsprozess zu unterstützen.'
    },
    howItWorks: {
      title: 'Wie es funktioniert',
      steps: [
        { title: 'Wähle einen Service', description: 'Wähle aus unserem Angebot an Energieheilungssitzungen, die auf deine Bedürfnisse zugeschnitten sind.' },
        { title: 'Buche im Voraus', description: 'Plane deine Sitzung zu einer Zeit, die am besten zu deiner Reise passt.' },
        { title: 'Energiearbeit', description: 'Empfange Heilungsenergie aus der Ferne oder durch geführte Sitzungen per Anruf.' },
        { title: 'Integration & Unterstützung', description: 'Setze deine Heilungsreise mit fortlaufender Anleitung und Unterstützung fort.' }
      ]
    },
    services: {
      title: 'Unsere Dienste',
      loading: 'Dienste werden geladen...',
      empty: 'Derzeit sind keine Dienste verfügbar.',
      viewAll: 'Alle Dienste anzeigen'
    },
    benefits: {
      title: 'Warum Energiearbeit ausprobieren',
      items: [
        { title: 'Emotionale Balance', text: 'Löse emotionale Blockaden und finde inneren Frieden durch sanfte Energieheilung.' },
        { title: 'Mentale Klarheit', text: 'Kläre mentale Trübungen und verbessere deine Konzentration mit ausgewogenem Energiefluss durch dein gesamtes Wesen.' },
        { title: 'Spirituelle Ausrichtung', text: 'Verbinde dich mit deinem höheren Selbst und richte dich auf deinen wahren Zweck und Weg aus.' },
        { title: 'Körperliches Wohlbefinden', text: 'Unterstütze die natürlichen Heilungsprozesse deines Körpers und fördere allgemeines Wohlbefinden.' }
      ]
    },
    sessions: {
      title: 'Geführte & Fernsitzungen',
      cards: [
        {
          title: 'Ferne Energiesitzungen',
          description: 'Empfange Heilungsenergie von überall auf der Welt. Unsere Praktizierenden kanalisieren universelle Energie aus der Ferne zu dir und schaffen eine kraftvolle Verbindung, die physische Distanz überwindet. Perfekt für diejenigen, die Flexibilität und Komfort suchen.',
          image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&q=80',
          alt: 'Ferne Energieheilung'
        },
        {
          title: 'Geführte Sitzungen per Anruf',
          description: 'Erlebe persönliche Anleitung während deiner Sitzung. Verbinde dich per Telefon oder Videoanruf, während unsere Praktizierenden dich durch den Heilungsprozess führen und Echtzeit-Unterstützung und Einblicke bieten.',
          image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80',
          alt: 'Geführte Heilungssitzung'
        }
      ]
    },
    testimonials: {
      title: 'Energieerfahrungen',
      items: [
        { text: '"Eine transformative Erfahrung, die tiefen Frieden und Klarheit brachte."', author: '— Kommt bald' },
        { text: '"Der Energiefluss war sanft aber kraftvoll und ließ mich erneuert fühlen."', author: '— Kommt bald' },
        { text: '"ManaWave half mir, eine Balance zu finden, von der ich nicht wusste, dass sie mir fehlte."', author: '— Kommt bald' }
      ]
    },
    cta: {
      title: 'Beginne deine Reise',
      text: 'Mache den ersten Schritt zu Balance, Heilung und Ausrichtung. Deine Energiereise wartet auf dich.',
      button: 'Starte deine Sitzung'
    },
    partners: {
      title: 'Unsere Partner'
    }
  },
  French: {
    heroTagline: 'Plongez dans votre énergie',
    heroPrimary: 'Explorer les Services',
    heroSecondary: 'Réserver une Séance',
    intro: {
      title: 'Bienvenue chez ManaWave',
      text: 'ManaWave est un sanctuaire pour la guérison énergétique et le bien-être spirituel. Grâce à l\'ancienne pratique du Reiki et du travail énergétique universel, nous vous guidons vers l\'équilibre, la guérison et l\'alignement. Découvrez le flux doux de l\'énergie qui relie l\'esprit, le corps et l\'âme, créant l\'harmonie en vous et autour de vous.'
    },
    reiki: {
      title: 'Qu\'est-ce que le Reiki et l\'Énergie Universelle',
      text: 'Le Reiki est une technique de guérison japonaise qui canalise l\'énergie vitale universelle par un toucher doux ou l\'intention. Cette énergie circule naturellement à travers tous les êtres vivants, favorisant la guérison physique, émotionnelle et spirituelle. Chez ManaWave, nous travaillons avec cette énergie universelle pour aider à rétablir l\'équilibre, libérer les blocages et soutenir votre processus de guérison naturel.'
    },
    howItWorks: {
      title: 'Comment ça fonctionne',
      steps: [
        { title: 'Choisir un Service', description: 'Sélectionnez parmi notre gamme de séances de guérison énergétique adaptées à vos besoins.' },
        { title: 'Réserver à l\'avance', description: 'Planifiez votre séance à un moment qui convient le mieux à votre parcours.' },
        { title: 'Travail Énergétique', description: 'Recevez l\'énergie de guérison à distance ou lors de séances guidées sur appel.' },
        { title: 'Intégration et Soutien', description: 'Poursuivez votre parcours de guérison avec un accompagnement et un soutien continus.' }
      ]
    },
    services: {
      title: 'Nos Services',
      loading: 'Chargement des services...',
      empty: 'Aucun service disponible pour le moment.',
      viewAll: 'Voir Tous les Services'
    },
    benefits: {
      title: 'Pourquoi Essayer le Travail Énergétique',
      items: [
        { title: 'Équilibre Émotionnel', text: 'Libérez les blocages émotionnels et trouvez la paix intérieure grâce à une guérison énergétique douce.' },
        { title: 'Clarté Mentale', text: 'Dissipez le brouillard mental et améliorez la concentration avec un flux d\'énergie équilibré dans tout votre être.' },
        { title: 'Alignement Spirituel', text: 'Connectez-vous avec votre moi supérieur et alignez-vous avec votre véritable but et chemin.' },
        { title: 'Bien-être Physique', text: 'Soutenez les processus de guérison naturels de votre corps et favorisez le bien-être général.' }
      ]
    },
    sessions: {
      title: 'Séances Guidées et à Distance',
      cards: [
        {
          title: 'Séances Énergétiques à Distance',
          description: 'Recevez l\'énergie de guérison depuis n\'importe où dans le monde. Nos praticiens canalisent l\'énergie universelle vers vous à distance, créant une connexion puissante qui transcende la distance physique. Parfait pour ceux qui recherchent flexibilité et confort.',
          image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&q=80',
          alt: 'Guérison énergétique à distance'
        },
        {
          title: 'Séances Guidées sur Appel',
          description: 'Vivez un accompagnement personnalisé pendant votre séance. Connectez-vous par téléphone ou appel vidéo tandis que nos praticiens vous guident à travers le processus de guérison, offrant un soutien et des insights en temps réel.',
          image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80',
          alt: 'Séance de guérison guidée'
        }
      ]
    },
    testimonials: {
      title: 'Expériences Énergétiques',
      items: [
        { text: '"Une expérience transformatrice qui a apporté une paix et une clarté profondes."', author: '— Bientôt disponible' },
        { text: '"Le flux d\'énergie était doux mais puissant, me laissant un sentiment de renouveau."', author: '— Bientôt disponible' },
        { text: '"ManaWave m\'a aidé à trouver un équilibre que je ne savais pas manquer."', author: '— Bientôt disponible' }
      ]
    },
    cta: {
      title: 'Commencez Votre Voyage',
      text: 'Faites le premier pas vers l\'équilibre, la guérison et l\'alignement. Votre voyage énergétique vous attend.',
      button: 'Commencer Votre Séance'
    },
    partners: {
      title: 'Nos Partenaires'
    }
  }
};

export const aboutPageCopy = {
  English: {
    pageTitle: 'About ManaWave',
    pageSubtitle: 'Flow into your energy',
    essenceTitle: 'Our Essence',
    essenceParagraphs: [
      'ManaWave is a sanctuary for energy healing and spiritual wellness, dedicated to guiding you toward balance, healing, and alignment. Through the gentle flow of universal energy, we create a space where mind, body, and spirit can harmonize naturally.',
      'We believe in the power of energy work to restore balance, release blockages, and support your natural healing process. Every session is conducted with respect, intention, and a deep commitment to your wellbeing.'
    ],
    whatWeDoTitle: 'What We Do',
    whatWeDoCards: [
      {
        title: 'Remote Energy Sessions',
        description: 'Receive powerful healing energy from anywhere in the world. Our practitioners channel universal energy remotely, creating a connection that transcends physical distance.'
      },
      {
        title: 'Guided On-Call Sessions',
        description: 'Experience personalized guidance during your session. Connect via phone or video call as our practitioners guide you through the healing process with real-time support.'
      },
      {
        title: 'Trainings & Attunements',
        description: 'Deepen your connection with energy work through specialized trainings and attunements designed to enhance your spiritual practice and personal growth.'
      },
      {
        title: 'Energy Coaching & Integration',
        description: 'Receive ongoing guidance between sessions with personalized energy coaching, integration practices, and accountability to help you embody the healing insights you receive.'
      }
    ],
    deliveryTitle: 'How Sessions Are Delivered',
    remoteIndicator: 'Remote',
    remoteTitle: 'Remote Sessions',
    remoteDescription: 'No call required. Our practitioners channel healing energy to you remotely, creating a powerful connection that works across any distance. Simply find a quiet space, relax, and receive the energy.',
    onCallIndicator: 'On-Call',
    onCallTitle: 'On-Call Guided Sessions',
    onCallDescription: 'Connect via phone or video call for real-time guidance. Our practitioners will guide you through the session, offering support, insights, and personalized attention throughout your healing journey.',
    philosophyTitle: 'Our Philosophy & Intention',
    philosophyCards: [
      {
        title: 'Safety First',
        text: 'Your safety and wellbeing are our highest priorities. All sessions are conducted with the utmost care, respect, and professional energy work practices.'
      },
      {
        title: 'Respect & Free Will',
        text: 'We honor your free will and personal boundaries. Every session respects your autonomy, and you remain in control of your healing journey at all times.'
      },
      {
        title: 'Energetic Balance',
        text: 'We work with universal energy to restore natural balance and harmony. Our approach supports your body’s innate healing abilities without force or manipulation.'
      },
      {
        title: 'Authentic Connection',
        text: 'We believe in genuine, heart-centered connections. Every interaction is approached with authenticity, compassion, and a sincere desire to support your wellbeing.'
      },
      {
        title: 'Community Care',
        text: 'We nurture a supportive community where shared experiences and compassion enhance every step of your healing path.'
      },
      {
        title: 'Personal Empowerment',
        text: 'We guide you to reclaim your inner strength and integrate energetic insights into daily life with confidence.'
      }
    ],
    ctaTitle: 'Begin Your Journey',
    ctaSubtitle: 'Experience the gentle flow of energy that connects mind, body, and spirit',
    ctaButton: 'Explore Services'
  },
  Arabic: {
    pageTitle: 'عن ماناويف',
    pageSubtitle: 'انطلق في طاقتك',
    essenceTitle: 'جوهرنا',
    essenceParagraphs: [
      'ماناويف هو ملاذ للشفاء الطاقي والرفاهية الروحية، مكرّس لإرشادك نحو التوازن والشفاء والانسجام. من خلال تدفق لطيف للطاقة الكونية، نخلق مساحة حيث يتناغم العقل والجسم والروح بشكل طبيعي.',
      'نؤمن بقدرة العمل الطاقي على استعادة التوازن، تحرير العوائق، ودعم مسارك الطبيعي للشفاء. تُدار كل جلسة باحترام، نية، والتزام عميق برفاهيتك.'
    ],
    whatWeDoTitle: 'ما الذي نفعله',
    whatWeDoCards: [
      {
        title: 'جلسات الطاقة عن بعد',
        description: 'تلقي طاقة شافية قوية من أي مكان في العالم. يوجه ممارسونا الطاقة الكونية عن بعد، مما يخلق اتصالاً يتجاوز المسافات المادية.'
      },
      {
        title: 'جلسات موجهة عند الطلب',
        description: 'اختبر الإرشاد الشخصي خلال جلستك. تواصل عبر الهاتف أو الفيديو بينما يوجهك الممارسون خلال عملية الشفاء بدعم فوري.'
      },
      {
        title: 'تدريبات وتوليفات',
        description: 'عمّق اتصالك مع العمل الطاقي من خلال تدريبات وتوليفات متخصصة تعزز ممارستك الروحية والنمو الشخصي.'
      },
      {
        title: 'الإرشاد الطاقي والتكامل',
        description: 'احصل على دعم مستمر بين الجلسات من خلال إرشاد طاقي مخصص وممارسات تكامل تساعدك على تجسيد الرؤى الشفائية التي تتلقاها.'
      }
    ],
    deliveryTitle: 'كيف تُقدّم الجلسات',
    remoteIndicator: 'عن بعد',
    remoteTitle: 'الجلسات عن بعد',
    remoteDescription: 'لا حاجة للاتصال. يوجه ممارسونا الطاقة إليك عن بعد، مما يخلق اتصالاً قويًا يشمل أي مسافة. فقط اجد مكانًا هادئًا، استرخ، وتلقَّ الطاقة.',
    onCallIndicator: 'عند الطلب',
    onCallTitle: 'جلسات موجهة عند الطلب',
    onCallDescription: 'اتصل عبر الهاتف أو الفيديو للحصول على إرشاد فوري. يرشدك الممارسون خلال الجلسة، مقدمين دعمًا ورؤى واهتمامًا شخصيًا.',
    philosophyTitle: 'فلسفتنا ونوايانا',
    philosophyCards: [
      {
        title: 'السلامة أولاً',
        text: 'سلامتك ورفاهيتك هما أولويتنا الأعلى. تتم جميع الجلسات بعناية واحترام وممارسات طاقية مهنية.'
      },
      {
        title: 'الاحترام والإرادة الحرة',
        text: 'نُقدّر إرادتك الحرة وحدودك الشخصية. تحترم كل جلسة استقلاليتك، وتظل مسيطرًا على رحلة شفائك.'
      },
      {
        title: 'التوازن الطاقي',
        text: 'نعمل مع الطاقة الكونية لاستعادة التوازن الطبيعي والانسجام. يدعم نهجنا قدرات جسدك الخاصة على الشفاء دون إكراه.'
      },
      {
        title: 'الاتصال الأصيل',
        text: 'نؤمن بالاتصالات الحقيقية من القلب. تُبنى كل تفاعل على الأصالة والتعاطف ورغبة صادقة في دعم رفاهيتك.'
      },
      {
        title: 'رعاية المجتمع',
        text: 'نُغذّي مجتمعًا داعمًا حيث تعزز الخبرات المشتركة والرحمة كل خطوة في مسار شفائك.'
      },
      {
        title: 'التمكين الشخصي',
        text: 'نرشدك لاستعادة قوتك الداخلية ودمج الرؤى الطاقية في حياتك اليومية بثقة.'
      }
    ],
    ctaTitle: 'ابدأ رحلتك',
    ctaSubtitle: 'اختبر تدفق الطاقة اللطيف الذي يربط العقل والجسم والروح',
    ctaButton: 'استكشف الخدمات'
  },
  Russian: {
    pageTitle: 'О ManaWave',
    pageSubtitle: 'Погрузитесь в свою энергию',
    essenceTitle: 'Наша сущность',
    essenceParagraphs: [
      'ManaWave — это убежище для энергетического исцеления и духовного благополучия, направленное на то, чтобы вести вас к балансу, исцелению и гармонии. Через мягкий поток универсальной энергии мы создаем пространство, где разум, тело и дух могут естественно сочетаться.',
      'Мы верим в силу энергетической работы для восстановления баланса, освобождения от блоков и поддержки вашего естественного пути исцеления. Каждая сессия проводится с уважением, намерением и глубокой приверженностью вашему благополучию.'
    ],
    whatWeDoTitle: 'Что мы делаем',
    whatWeDoCards: [
      {
        title: 'Удалённые энергетические сессии',
        description: 'Получайте мощную исцеляющую энергию из любой точки планеты. Наши практики направляют универсальную энергию дистанционно, создавая связь, которая превосходит физическую дистанцию.'
      },
      {
        title: 'Гидируемые сессии по вызову',
        description: 'Получите персональное руководство во время сессии. Общайтесь по телефону или видеосвязи, пока наши практики ведут вас через процесс исцеления с поддержкой в реальном времени.'
      },
      {
        title: 'Обучение и настройка',
        description: 'Углубляйте свою связь с энергетической работой через специальные тренинги и настройки, которые усиливают вашу духовную практику и личностный рост.'
      },
      {
        title: 'Коучинг и интеграция энергии',
        description: 'Получайте постоянную поддержку между сессиями через персональный энергетический коучинг, практики интеграции и контроль прогресса, чтобы закрепить исцеляющие открытия.'
      }
    ],
    deliveryTitle: 'Как проходят сессии',
    remoteIndicator: 'Удалённо',
    remoteTitle: 'Удалённые сессии',
    remoteDescription: 'Не нужно звонить. Наши практики направляют исцеляющую энергию к вам дистанционно, создавая мощную связь на любом расстоянии. Найдите тихое место, расслабьтесь и принимайте энергию.',
    onCallIndicator: 'По вызову',
    onCallTitle: 'Гидируемые сессии по вызову',
    onCallDescription: 'Соединяйтесь по телефону или видео для получения руководства в реальном времени. Практики ведут вас через сессию, предлагая поддержку, прозрения и персональное внимание.',
    philosophyTitle: 'Наша философия и намерения',
    philosophyCards: [
      {
        title: 'Безопасность прежде всего',
        text: 'Ваша безопасность и благополучие — наш приоритет. Все сессии проводятся с максимальной заботой, уважением и профессиональными энергетическими практиками.'
      },
      {
        title: 'Уважение и свобода воли',
        text: 'Мы уважаем вашу свободу воли и личные границы. Каждая сессия уважает вашу автономию, и вы сохраняете контроль над своим исцеляющим путешествием.'
      },
      {
        title: 'Энергетическое равновесие',
        text: 'Мы работаем с универсальной энергией, чтобы восстановить естественный баланс и гармонию. Наш подход поддерживает врожденные способности вашего тела к исцелению без принуждения.'
      },
      {
        title: 'Подлинная связь',
        text: 'Мы верим в искренние, сердечные связи. Каждое взаимодействие строится на подлинности, сострадании и искреннем желании поддержать ваше благополучие.'
      },
      {
        title: 'Забота о сообществе',
        text: 'Мы создаем пространство поддержки, где общее сопереживание и забота усиливают путь исцеления каждого.'
      },
      {
        title: 'Личная сила',
        text: 'Мы помогаем вам вернуть внутреннюю силу и уверенно интегрировать энергетические открытия в повседневную жизнь.'
      }
    ],
    ctaTitle: 'Начните ваше путешествие',
    ctaSubtitle: 'Ощутите мягкий поток энергии, соединяющий разум, тело и дух',
    ctaButton: 'Изучить услуги'
  },
  German: {
    pageTitle: 'Über ManaWave',
    pageSubtitle: 'Fließe in deine Energie',
    essenceTitle: 'Unser Wesen',
    essenceParagraphs: [
      'ManaWave ist ein Zufluchtsort für Energieheilung und spirituelles Wohlbefinden, der sich der Führung zu Balance, Heilung und Ausrichtung widmet. Durch den sanften Fluss universeller Energie schaffen wir einen Raum, in dem Geist, Körper und Seele natürlich harmonisieren können.',
      'Wir glauben an die Kraft der Energiearbeit, um Balance wiederherzustellen, Blockaden zu lösen und deinen natürlichen Heilungsprozess zu unterstützen. Jede Sitzung wird mit Respekt, Absicht und einem tiefen Engagement für dein Wohlbefinden durchgeführt.'
    ],
    whatWeDoTitle: 'Was wir tun',
    whatWeDoCards: [
      {
        title: 'Ferne Energiesitzungen',
        description: 'Empfange kraftvolle Heilungsenergie von überall auf der Welt. Unsere Praktizierenden kanalisieren universelle Energie aus der Ferne und schaffen eine Verbindung, die physische Distanz überwindet.'
      },
      {
        title: 'Geführte Sitzungen auf Abruf',
        description: 'Erlebe persönliche Anleitung während deiner Sitzung. Verbinde dich per Telefon oder Videoanruf, während unsere Praktizierenden dich durch den Heilungsprozess führen und Echtzeit-Unterstützung bieten.'
      },
      {
        title: 'Ausbildungen & Einstimmungen',
        description: 'Vertiefe deine Verbindung mit Energiearbeit durch spezialisierte Ausbildungen und Einstimmungen, die darauf ausgelegt sind, deine spirituelle Praxis und persönliches Wachstum zu fördern.'
      },
      {
        title: 'Energie-Coaching & Integration',
        description: 'Erhalte fortlaufende Anleitung zwischen Sitzungen mit personalisiertem Energie-Coaching, Integrationspraktiken und Verantwortlichkeit, um dir zu helfen, die Heilungserkenntnisse, die du erhältst, zu verkörpern.'
      }
    ],
    deliveryTitle: 'Wie Sitzungen durchgeführt werden',
    remoteIndicator: 'Fern',
    remoteTitle: 'Fernsitzungen',
    remoteDescription: 'Kein Anruf erforderlich. Unsere Praktizierenden kanalisieren Heilungsenergie aus der Ferne zu dir und schaffen eine kraftvolle Verbindung, die über jede Distanz funktioniert. Finde einfach einen ruhigen Raum, entspanne dich und empfange die Energie.',
    onCallIndicator: 'Auf Abruf',
    onCallTitle: 'Geführte Sitzungen auf Abruf',
    onCallDescription: 'Verbinde dich per Telefon oder Videoanruf für Echtzeit-Anleitung. Unsere Praktizierenden führen dich durch die Sitzung und bieten Unterstützung, Einblicke und persönliche Aufmerksamkeit während deiner gesamten Heilungsreise.',
    philosophyTitle: 'Unsere Philosophie & Absicht',
    philosophyCards: [
      {
        title: 'Sicherheit zuerst',
        text: 'Deine Sicherheit und dein Wohlbefinden sind unsere höchsten Prioritäten. Alle Sitzungen werden mit größter Sorgfalt, Respekt und professionellen Energiearbeitspraktiken durchgeführt.'
      },
      {
        title: 'Respekt & freier Wille',
        text: 'Wir ehren deinen freien Willen und deine persönlichen Grenzen. Jede Sitzung respektiert deine Autonomie, und du behältst zu jeder Zeit die Kontrolle über deine Heilungsreise.'
      },
      {
        title: 'Energetisches Gleichgewicht',
        text: 'Wir arbeiten mit universeller Energie, um natürliches Gleichgewicht und Harmonie wiederherzustellen. Unser Ansatz unterstützt die angeborenen Heilungsfähigkeiten deines Körpers ohne Zwang oder Manipulation.'
      },
      {
        title: 'Authentische Verbindung',
        text: 'Wir glauben an echte, herzzentrierte Verbindungen. Jede Interaktion wird mit Authentizität, Mitgefühl und einem aufrichtigen Wunsch, dein Wohlbefinden zu unterstützen, angegangen.'
      },
      {
        title: 'Gemeinschaftspflege',
        text: 'Wir pflegen eine unterstützende Gemeinschaft, in der gemeinsame Erfahrungen und Mitgefühl jeden Schritt deines Heilungsweges bereichern.'
      },
      {
        title: 'Persönliche Ermächtigung',
        text: 'Wir führen dich dazu, deine innere Stärke zurückzugewinnen und energetische Erkenntnisse mit Selbstvertrauen in den Alltag zu integrieren.'
      }
    ],
    ctaTitle: 'Beginne deine Reise',
    ctaSubtitle: 'Erlebe den sanften Energiefluss, der Geist, Körper und Seele verbindet',
    ctaButton: 'Dienste erkunden'
  },
  French: {
    pageTitle: 'À Propos de ManaWave',
    pageSubtitle: 'Plongez dans votre énergie',
    essenceTitle: 'Notre Essence',
    essenceParagraphs: [
      'ManaWave est un sanctuaire pour la guérison énergétique et le bien-être spirituel, dédié à vous guider vers l\'équilibre, la guérison et l\'alignement. Grâce au flux doux de l\'énergie universelle, nous créons un espace où l\'esprit, le corps et l\'âme peuvent s\'harmoniser naturellement.',
      'Nous croyons en la puissance du travail énergétique pour restaurer l\'équilibre, libérer les blocages et soutenir votre processus de guérison naturel. Chaque séance est menée avec respect, intention et un engagement profond envers votre bien-être.'
    ],
    whatWeDoTitle: 'Ce Que Nous Faisons',
    whatWeDoCards: [
      {
        title: 'Séances Énergétiques à Distance',
        description: 'Recevez une énergie de guérison puissante depuis n\'importe où dans le monde. Nos praticiens canalisent l\'énergie universelle à distance, créant une connexion qui transcende la distance physique.'
      },
      {
        title: 'Séances Guidées sur Appel',
        description: 'Vivez un accompagnement personnalisé pendant votre séance. Connectez-vous par téléphone ou appel vidéo tandis que nos praticiens vous guident à travers le processus de guérison avec un soutien en temps réel.'
      },
      {
        title: 'Formations et Harmonisations',
        description: 'Approfondissez votre connexion avec le travail énergétique grâce à des formations et harmonisations spécialisées conçues pour améliorer votre pratique spirituelle et votre croissance personnelle.'
      },
      {
        title: 'Coaching Énergétique et Intégration',
        description: 'Recevez un accompagnement continu entre les séances avec un coaching énergétique personnalisé, des pratiques d\'intégration et de responsabilisation pour vous aider à intégrer les insights de guérison que vous recevez.'
      }
    ],
    deliveryTitle: 'Comment les Séances sont Proposées',
    remoteIndicator: 'À Distance',
    remoteTitle: 'Séances à Distance',
    remoteDescription: 'Aucun appel requis. Nos praticiens canalisent l\'énergie de guérison vers vous à distance, créant une connexion puissante qui fonctionne quelle que soit la distance. Trouvez simplement un espace calme, détendez-vous et recevez l\'énergie.',
    onCallIndicator: 'Sur Appel',
    onCallTitle: 'Séances Guidées sur Appel',
    onCallDescription: 'Connectez-vous par téléphone ou appel vidéo pour un accompagnement en temps réel. Nos praticiens vous guideront à travers la séance, offrant soutien, insights et attention personnalisée tout au long de votre parcours de guérison.',
    philosophyTitle: 'Notre Philosophie et Intention',
    philosophyCards: [
      {
        title: 'La Sécurité d\'Abord',
        text: 'Votre sécurité et votre bien-être sont nos priorités absolues. Toutes les séances sont menées avec le plus grand soin, respect et pratiques professionnelles de travail énergétique.'
      },
      {
        title: 'Respect et Libre Arbitre',
        text: 'Nous honorons votre libre arbitre et vos limites personnelles. Chaque séance respecte votre autonomie, et vous gardez le contrôle de votre parcours de guérison à tout moment.'
      },
      {
        title: 'Équilibre Énergétique',
        text: 'Nous travaillons avec l\'énergie universelle pour restaurer l\'équilibre naturel et l\'harmonie. Notre approche soutient les capacités de guérison innées de votre corps sans force ni manipulation.'
      },
      {
        title: 'Connexion Authentique',
        text: 'Nous croyons en des connexions authentiques et centrées sur le cœur. Chaque interaction est abordée avec authenticité, compassion et un désir sincère de soutenir votre bien-être.'
      },
      {
        title: 'Soin Communautaire',
        text: 'Nous nourrissons une communauté bienveillante où les expériences partagées et la compassion enrichissent chaque étape de votre chemin de guérison.'
      },
      {
        title: 'Autonomisation Personnelle',
        text: 'Nous vous guidons pour retrouver votre force intérieure et intégrer les insights énergétiques dans la vie quotidienne avec confiance.'
      }
    ],
    ctaTitle: 'Commencez Votre Voyage',
    ctaSubtitle: 'Découvrez le flux doux de l\'énergie qui relie l\'esprit, le corps et l\'âme',
    ctaButton: 'Explorer les Services'
  }
};

export const loginPageCopy = {
  English: {
    title: 'Welcome Back',
    subtitle: 'Continue your journey toward balance and healing',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Password',
    forgotPassword: 'Forgot Password?',
    loginButton: 'Login',
    loggingIn: 'Logging in...',
    alternateText: "Don't have an account?",
    signUp: 'Sign Up',
    privacyNote: 'We respect your privacy. Your data is safe.',
    errors: {
      emailRequired: 'Email is required',
      emailInvalid: 'Email is invalid',
      passwordRequired: 'Password is required',
      invalidCredentials: 'Invalid email or password. Please try again.',
      unexpected: 'An unexpected error occurred. Please try again.'
    }
  },
  Arabic: {
    title: 'مرحباً بعودتك',
    subtitle: 'واصل رحلتك نحو التوازن والشفاء',
    emailPlaceholder: 'البريد الإلكتروني',
    passwordPlaceholder: 'كلمة المرور',
    forgotPassword: 'نسيت كلمة المرور؟',
    loginButton: 'تسجيل الدخول',
    loggingIn: 'جاري تسجيل الدخول...',
    alternateText: 'لا تملك حساباً؟',
    signUp: 'إنشاء حساب',
    privacyNote: 'نحترم خصوصيتك. بياناتك آمنة.',
    errors: {
      emailRequired: 'البريد الإلكتروني مطلوب',
      emailInvalid: 'البريد الإلكتروني غير صالح',
      passwordRequired: 'كلمة المرور مطلوبة',
      invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة. حاول مرة أخرى.',
      unexpected: 'حدث خطأ غير متوقع. حاول مرة أخرى.'
    }
  },
  Russian: {
    title: 'С возвращением',
    subtitle: 'Продолжайте путь к балансу и исцелению',
    emailPlaceholder: 'Электронная почта',
    passwordPlaceholder: 'Пароль',
    forgotPassword: 'Забыли пароль?',
    loginButton: 'Войти',
    loggingIn: 'Выполняется вход...',
    alternateText: 'Нет аккаунта?',
    signUp: 'Зарегистрироваться',
    privacyNote: 'Мы уважаем вашу приватность. Ваши данные в безопасности.',
    errors: {
      emailRequired: 'Требуется электронная почта',
      emailInvalid: 'Электронная почта недействительна',
      passwordRequired: 'Требуется пароль',
      invalidCredentials: 'Неверная почта или пароль. Попробуйте снова.',
      unexpected: 'Произошла ошибка. Попробуйте снова.'
    }
  },
  German: {
    title: 'Willkommen zurück',
    subtitle: 'Setze deine Reise zu Balance und Heilung fort',
    emailPlaceholder: 'E-Mail',
    passwordPlaceholder: 'Passwort',
    forgotPassword: 'Passwort vergessen?',
    loginButton: 'Anmelden',
    loggingIn: 'Wird angemeldet...',
    alternateText: 'Noch kein Konto?',
    signUp: 'Registrieren',
    privacyNote: 'Wir respektieren deine Privatsphäre. Deine Daten sind sicher.',
    errors: {
      emailRequired: 'E-Mail ist erforderlich',
      emailInvalid: 'E-Mail ist ungültig',
      passwordRequired: 'Passwort ist erforderlich',
      invalidCredentials: 'Ungültige E-Mail oder Passwort. Bitte versuche es erneut.',
      unexpected: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.'
    }
  },
  French: {
    title: 'Bon Retour',
    subtitle: 'Continuez votre voyage vers l\'équilibre et la guérison',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    loginButton: 'Se connecter',
    loggingIn: 'Connexion en cours...',
    alternateText: 'Vous n\'avez pas de compte ?',
    signUp: 'Créer un compte',
    privacyNote: 'Nous respectons votre vie privée. Vos données sont sécurisées.',
    errors: {
      emailRequired: 'L\'email est requis',
      emailInvalid: 'L\'email n\'est pas valide',
      passwordRequired: 'Le mot de passe est requis',
      invalidCredentials: 'Email ou mot de passe invalide. Veuillez réessayer.',
      unexpected: 'Une erreur inattendue s\'est produite. Veuillez réessayer.'
    }
  }
};

export const servicesPageCopy = {
  English: {
    title: 'Services',
    subtitle: 'Discover energy alignment and flow through our transformative healing sessions. Each service is designed to guide you toward balance, clarity, and spiritual wellness.',
    filters: {
      All: 'All',
      Remote: 'Remote Sessions',
      'On-Call': 'On-Call Sessions',
      'Healing Session': 'Healing Sessions',
      'Training Session': 'Training Sessions',
      'Specialists': 'Specialists',
      'Training Sessions': 'Training Sessions'
    },
    loading: 'Loading services...',
    error: 'Failed to load services. Please try again.',
    noResults: (label, allLabel) =>
      label === allLabel ? 'No services found.' : `No services found for ${label}.`,
    noSpecialists: 'No specialists found.',
    noTrainingSessions: 'No training sessions found.',
    viewDetails: 'View Details',
    footer: '© 2026 ManaWave. All rights reserved.',
    labels: {
      specialization: 'Specialization:',
      experience: 'Experience:',
      years: 'years',
      languages: 'Languages:',
      certifications: 'Certifications:',
      trainer: 'Trainer'
    }
  },
  Arabic: {
    title: 'خدماتنا',
    subtitle: 'اكتشف التناغم الطاقي من خلال جلسات الشفاء التحولية لدينا. كل خدمة مصممة لتوجهك نحو التوازن والوضوح والرفاهية الروحية.',
    filters: {
      All: 'الكل',
      Remote: 'جلسات عن بعد',
      'On-Call': 'جلسات عند الطلب',
      'Healing Session': 'جلسات الشفاء',
      'Training Session': 'جلسات التدريب',
      'Specialists': 'الأخصائيون',
      'Training Sessions': 'جلسات التدريب'
    },
    loading: 'جاري تحميل الخدمات...',
    error: 'فشل في تحميل الخدمات. يرجى المحاولة مرة أخرى.',
    noResults: (label, allLabel) =>
      label === allLabel ? 'لا توجد خدمات.' : `لا توجد خدمات لـ${label}.`,
    noSpecialists: 'لا يوجد أخصائيون.',
    noTrainingSessions: 'لا توجد جلسات تدريب.',
    viewDetails: 'عرض التفاصيل',
    footer: '© 2026 ManaWave. جميع الحقوق محفوظة.',
    labels: {
      specialization: 'التخصص:',
      experience: 'الخبرة:',
      years: 'سنوات',
      languages: 'اللغات:',
      certifications: 'الشهادات:',
      trainer: 'مدرب'
    }
  },
  Russian: {
    title: 'Услуги',
    subtitle: 'Откройте для себя энергетическое равновесие и поток через наши трансформирующие целительные сессии. Каждая услуга создана, чтобы вести вас к гармонии, ясности и духовному благополучию.',
    filters: {
      All: 'Все',
      Remote: 'Удалённые сессии',
      'On-Call': 'Сессии по вызову',
      'Healing Session': 'Сессии исцеления',
      'Training Session': 'Обучающие сессии',
      'Specialists': 'Специалисты',
      'Training Sessions': 'Обучающие сессии'
    },
    loading: 'Загрузка услуг...',
    error: 'Не удалось загрузить услуги. Попробуйте снова.',
    noResults: (label, allLabel) =>
      label === allLabel ? 'Сервисы не найдены.' : `Сервисы не найдены для ${label}.`,
    noSpecialists: 'Специалисты не найдены.',
    noTrainingSessions: 'Обучающие сессии не найдены.',
    viewDetails: 'Подробнее',
    footer: '© 2026 ManaWave. Все права защищены.',
    labels: {
      specialization: 'Специализация:',
      experience: 'Опыт:',
      years: 'лет',
      languages: 'Языки:',
      certifications: 'Сертификаты:',
      trainer: 'Тренер'
    }
  },
  German: {
    title: 'Dienste',
    subtitle: 'Entdecke Energieausrichtung und Fluss durch unsere transformativen Heilungssitzungen. Jeder Service ist darauf ausgelegt, dich zu Balance, Klarheit und spirituellem Wohlbefinden zu führen.',
    filters: {
      All: 'Alle',
      Remote: 'Fernsitzungen',
      'On-Call': 'Sitzungen auf Abruf',
      'Healing Session': 'Heilungssitzungen',
      'Training Session': 'Ausbildungssitzungen',
      'Specialists': 'Spezialisten',
      'Training Sessions': 'Ausbildungssitzungen'
    },
    loading: 'Dienste werden geladen...',
    error: 'Fehler beim Laden der Dienste. Bitte versuche es erneut.',
    noResults: (label, allLabel) =>
      label === allLabel ? 'Keine Dienste gefunden.' : `Keine Dienste gefunden für ${label}.`,
    noSpecialists: 'Keine Spezialisten gefunden.',
    noTrainingSessions: 'Keine Ausbildungssitzungen gefunden.',
    viewDetails: 'Details anzeigen',
    footer: '© 2026 ManaWave. Alle Rechte vorbehalten.',
    labels: {
      specialization: 'Spezialisierung:',
      experience: 'Erfahrung:',
      years: 'Jahre',
      languages: 'Sprachen:',
      certifications: 'Zertifizierungen:',
      trainer: 'Ausbilder'
    }
  },
  French: {
    title: 'Services',
    subtitle: 'Découvrez l\'alignement énergétique et le flux à travers nos séances de guérison transformatrices. Chaque service est conçu pour vous guider vers l\'équilibre, la clarté et le bien-être spirituel.',
    filters: {
      All: 'Tous',
      Remote: 'Séances à Distance',
      'On-Call': 'Séances sur Appel',
      'Healing Session': 'Séances de Guérison',
      'Training Session': 'Séances de Formation',
      'Specialists': 'Spécialistes',
      'Training Sessions': 'Séances de Formation'
    },
    loading: 'Chargement des services...',
    error: 'Échec du chargement des services. Veuillez réessayer.',
    noResults: (label, allLabel) =>
      label === allLabel ? 'Aucun service trouvé.' : `Aucun service trouvé pour ${label}.`,
    noSpecialists: 'Aucun spécialiste trouvé.',
    noTrainingSessions: 'Aucune séance de formation trouvée.',
    viewDetails: 'Voir les Détails',
    footer: '© 2026 ManaWave. Tous droits réservés.',
    labels: {
      specialization: 'Spécialisation :',
      experience: 'Expérience :',
      years: 'ans',
      languages: 'Langues :',
      certifications: 'Certifications :',
      trainer: 'Formateur'
    }
  }
};

export const serviceTranslations = {
  'Get rid of addiction (cigarettes, alcohol, etc) course': {
    Arabic: {
      name: 'إزالة الإدمان (سجائر، كحول، إلخ)',
      duration: '١٠ جلسات',
      price: '€700',
      description: 'دورة شاملة مكونة من ١٠ جلسات مصمّمة لمساعدتك على التغلب على الإدمان مثل السجائر والكحول والاعتماديات الأخرى. يوفّر هذا البرنامج المنظم دعمًا مستمرًا وعلاجًا طاقيًا لتحريرك من أنماط الإدمان واستعادة التوازن في حياتك.'
    },
    Russian: {
      name: 'Курс избавления от зависимостей',
      duration: '10 сеансов',
      price: '€700',
      description: 'Комплексный 10-сессионный курс, помогающий преодолеть зависимости (сигареты, алкоголь и другие). Программа обеспечивает постоянную поддержку и энергетическое исцеление, чтобы разорвать зависимости и вернуть гармонию в жизнь.'
    },
    German: {
      name: 'Kurs zur Befreiung von Süchten (Zigaretten, Alkohol, etc.)',
      duration: '10 Sitzungen',
      price: '€700',
      description: 'Ein umfassender 10-Sitzungs-Kurs, der dir hilft, Süchte wie Zigaretten, Alkohol und andere Abhängigkeiten zu überwinden. Das strukturierte Programm bietet kontinuierliche Unterstützung und Energieheilung, um dich von Suchtmustern zu befreien und das Gleichgewicht in deinem Leben wiederherzustellen.'
    },
    French: {
      name: 'Cours pour se libérer des dépendances (cigarettes, alcool, etc.)',
      duration: '10 séances',
      price: '€700',
      description: 'Un cours complet de 10 séances conçu pour vous aider à surmonter les dépendances telles que les cigarettes, l\'alcool et autres dépendances. Ce programme structuré fournit un soutien continu et une guérison énergétique pour vous libérer des schémas de dépendance et restaurer l\'équilibre dans votre vie.'
    }
  },
  'Create your talisman': {
    Arabic: {
      name: 'اصنع تميمتك',
      duration: '٣٠ دقيقة',
      price: '€30',
      description: 'اصنع تميمك الشخصي (خاتم، سوار، حجر...) ليكون معك دائمًا. يُشحن بالطاقة التي تختارها: للحب، المال، النمو المهني، التنوير، جذب الروح الطيبة، السلام العائلي، الحماية، أو أي نية أخرى. الجلسة تشمل ١٠ دقائق لشرح الرغبة، ١٥ دقيقة لملء التميمة بالطاقة، و٥ دقائق ملاحظات بعد الجلسة.'
    },
    Russian: {
      name: 'Создай свой талисман',
      duration: '30 минут',
      price: '€30',
      description: 'Создайте свой талисман (кольцо, браслет, камень), который всегда будет рядом. Наполните его желаемой энергией: для любви, денег, карьерного роста, просветления, привлечения родственной души, семейного мира, защиты или любой другой цели. Сессия включает 10 минут описания желания, 15 минут зарядки талисмана энергией и 5 минут обратной связи.'
    },
    German: {
      name: 'Erstelle dein Talisman',
      duration: '30 Minuten',
      price: '€30',
      description: 'Erstelle dein persönliches Talisman (Ring, Armband, Stein...), das immer bei dir ist. Es wird mit der Energie deiner Wahl aufgeladen: für Liebe, Geld, berufliches Wachstum, Erleuchtung, Anziehung einer Seelenverwandten, Familienfrieden, Schutz oder jede andere Absicht. Die Sitzung umfasst 10 Minuten zur Erklärung des Wunsches, 15 Minuten zum Aufladen des Talismans mit Energie und 5 Minuten Feedback nach der Sitzung.'
    },
    French: {
      name: 'Créez votre talisman',
      duration: '30 minutes',
      price: '€30',
      description: 'Créez votre talisman personnel (bague, bracelet, pierre...) pour qu\'il soit toujours avec vous. Il sera chargé de l\'énergie de votre choix : pour l\'amour, l\'argent, la croissance professionnelle, l\'illumination, attirer votre âme sœur, la paix familiale, la protection ou toute autre intention. La séance comprend 10 minutes pour expliquer votre souhait, 15 minutes pour charger le talisman d\'énergie et 5 minutes de retour après la séance.'
    }
  },
  'Sleep deep and quickly': {
    Arabic: {
      name: 'نم عميقاً وسريعاً',
      duration: '٣٠ دقيقة',
      price: '€55',
      description: 'جلسة مزدوجة تساعدك على النوم بسرعة وعمق، مع ١٥ دقيقة تنفس موجه وعد ١٥ دقيقة ريكي عن بعد لتسريع الاسترخاء وتهدئة العقل والجسم.'
    },
    Russian: {
      name: 'Глубокий и быстрый сон',
      duration: '30 минут',
      price: '€55',
      description: 'Двойная сессия для быстрого и глубокого сна: 15 минут дыхательных упражнений по счёту и 15 минут дистанционного рейки, чтобы успокоить ум, расслабить тело и погрузиться в восстановительный сон.'
    },
    German: {
      name: 'Tief und schnell schlafen',
      duration: '30 Minuten',
      price: '€55',
      description: 'Doppelte Sitzung, die dir hilft, schnell und tief zu schlafen, mit 15 Minuten geführter Atmung und 15 Minuten Fern-Reiki, um Entspannung zu beschleunigen und Geist und Körper zu beruhigen.'
    },
    French: {
      name: 'Dormir profondément et rapidement',
      duration: '30 minutes',
      price: '€55',
      description: 'Séance double qui vous aide à vous endormir rapidement et profondément, avec 15 minutes de respiration guidée et 15 minutes de Reiki à distance pour accélérer la relaxation et apaiser l\'esprit et le corps.'
    }
  },
  'Online Scanning': {
    Arabic: {
      name: 'الفحص عبر الإنترنت',
      duration: '٢٠ دقيقة',
      price: '€30'
      ,
      description: 'جلسة مسح طاقي قصيرة مدتها ٢٠ دقيقة لتحديد العوائق والمناطق التي تحتاج اهتمامًا في جسدك، مجال طاقتك، وشاكراتك.'
    },
    Russian: {
      name: 'Онлайн-сканирование',
      duration: '20 минут',
      price: '€30'
      ,
      description: 'Краткая 20-минутная сессия энергетического сканирования для выявления блоков и областей, требующих внимания в теле, энергетическом поле и чакрах.'
    },
    German: {
      name: 'Online-Scanning',
      duration: '20 Minuten',
      price: '€30',
      description: 'Eine kurze 20-minütige Energiescan-Sitzung zur Identifizierung von Blockaden und Bereichen, die Aufmerksamkeit in deinem Körper, deinem Energiefeld und deinen Chakren benötigen.'
    }
  },
  'Basic Body Health Alignment': {
    Arabic: {
      name: 'تنسيق الصحة الجسدية الأساسية',
      duration: 'ساعة',
      price: '€60'
      ,
      description: 'جلسة كاملة مدتها ساعة لإعادة التوازن والاتساق للجسم من خلال العمل الطاقي، داعمة للشفاء الطبيعي والرفاهية.'
    },
    Russian: {
      name: 'Базовое выравнивание здоровья тела',
      duration: '1 час',
      price: '€60'
      ,
      description: 'Полноценная часовая сессия для восстановления баланса и гармонии тела через энергетическую работу, поддерживающую естественное исцеление.'
    },
    German: {
      name: 'Grundlegende Körpergesundheits-Ausrichtung',
      duration: '1 Stunde',
      price: '€60',
      description: 'Eine vollständige einstündige Sitzung zur Wiederherstellung von Gleichgewicht und Harmonie des Körpers durch Energiearbeit, die natürliche Heilung und Wohlbefinden unterstützt.'
    },
    French: {
      name: 'Alignement de la Santé Corporelle de Base',
      duration: '1 heure',
      price: '€60',
      description: 'Une séance complète d\'une heure pour restaurer l\'équilibre et l\'alignement de votre corps physique grâce au travail énergétique, favorisant la guérison naturelle et le bien-être.'
    }
  },
  'Men Potency Boost': {
    Arabic: {
      name: 'تعزيز القدرة الذكورية',
      duration: 'ساعة',
      price: '€55'
      ,
      description: 'طاقة مركزة لتعزيز الحيوية والقوة وتدفق الطاقة الذكورية، مع أفضل نتائج عند إجراء سلسلة جلسات قصيرة.'
    },
    Russian: {
      name: 'Повышение мужской потенции',
      duration: '1 час',
      price: '€55'
      ,
      description: 'Специализированная работа с энергией для усиления жизненной силы, силы и общего мужского потока. Лучшие результаты достигаются коротким курсом сессий.'
    },
    German: {
      name: 'Männliche Potenzsteigerung',
      duration: '1 Stunde',
      price: '€55',
      description: 'Fokussierte Energiearbeit zur Steigerung von Vitalität, Kraft und männlichem Energiefluss, mit besten Ergebnissen bei einer kurzen Serie von Sitzungen.'
    },
    French: {
      name: 'Amélioration de la Puissance Masculine',
      duration: '1 heure',
      price: '€55',
      description: 'Travail énergétique spécialisé conçu pour améliorer la vitalité, la force et le flux énergétique masculin global. Les meilleurs résultats sont obtenus avec une courte série de séances.'
    }
  },
  'Specific Health Case Session': {
    Arabic: {
      name: 'جلسة حالة صحية محددة',
      duration: 'ساعة',
      price: '€70',
      description: 'جلسة شفاء طاقي مركّزة لمعالجة مشاكل صحية معينة، مع اهتمام شخصي. السعر يتغير حسب الحالة (€70-€500) ويحتاج أولاً جلسة مسح.'
    },
    Russian: {
      name: 'Сеанс по конкретному случаю здоровья',
      duration: '1 час',
      price: '€70',
      description: 'Целевая энергетическая сессия, направленная на конкретные проблемы со здоровьем с персонализированным вниманием. Цена варьируется (€70-€500) и требует предварительного сканирования.'
    },
    German: {
      name: 'Sitzung für spezifischen Gesundheitsfall',
      duration: '1 Stunde',
      price: '€70',
      description: 'Fokussierte Energieheilungssitzung zur Behandlung spezifischer Gesundheitsprobleme mit persönlicher Aufmerksamkeit. Der Preis variiert je nach Fall (€70-€500) und erfordert zunächst eine Scan-Sitzung.'
    }
  },
  'Home / Backyard / Workspace Scanning & Cleansing': {
    Arabic: {
      name: 'مسح وتنظيف المنزل / الفناء / مكان العمل',
      duration: 'يختلف حسب الحجم',
      price: '€3 لكل م²',
      description: 'تنقية طاقية شاملة لمساحات المعيشة أو العمل لإزالة الطاقة السلبية وإعادة التناغم. يتطلب فيديو أو خطة مرسومة، ويحسب السعر حسب الأمتار.'
    },
    Russian: {
      name: 'Сканирование и очищение дома / двора / рабочего места',
      duration: 'Зависит от площади',
      price: '€3 за м²',
      description: 'Энергетическая чистка жилых и рабочих пространств, чтобы убрать негатив и восстановить гармонию. Требуется план или видео помещения, цена рассчитывается за м².'
    },
    German: {
      name: 'Haus / Garten / Arbeitsplatz Scanning & Reinigung',
      duration: 'Variiert je nach Größe',
      price: '€3 pro m²',
      description: 'Umfassende energetische Reinigung von Wohn- oder Arbeitsräumen zur Entfernung negativer Energie und Wiederherstellung der Harmonie. Erfordert Video oder gezeichneter Plan, Preis wird nach Quadratmetern berechnet.'
    },
    French: {
      name: 'Analyse et Nettoyage du Domicile / Jardin / Espace de Travail',
      duration: 'Varie selon la taille',
      price: '€3 par m²',
      description: 'Purification énergétique complète de vos espaces de vie ou de travail pour éliminer l\'énergie négative et restaurer l\'harmonie. Nécessite une vidéo ou un plan dessiné de l\'espace. Prix calculé à €3 par mètre carré.'
    }
  },
  'Animal Reiki': {
    Arabic: {
      name: 'ريكي للحيوانات',
      duration: '٤٥ دقيقة',
      price: '€45',
      description: 'شفاء طاقي رقيق للحيوانات الأليفة يدعم صحتها الجسمية والعاطفية بحرارة وتعاطف.'
    },
    Russian: {
      name: 'Рейки для животных',
      duration: '45 минут',
      price: '€45',
      description: 'Нежное энергетическое исцеление для любимцев, стимулирующее их физическое и эмоциональное благополучие.'
    },
    German: {
      name: 'Tier-Reiki',
      duration: '45 Minuten',
      price: '€45',
      description: 'Sanfte Energieheilung für Haustiere, die ihre körperliche und emotionale Gesundheit mit Wärme und Mitgefühl unterstützt.'
    },
    French: {
      name: 'Reiki pour Animaux',
      duration: '45 minutes',
      price: '€45',
      description: 'Guérison énergétique douce pour vos animaux de compagnie bien-aimés, favorisant leur bien-être physique et émotionnel grâce à un travail énergétique compatissant.'
    }
  },
  'Children Reiki': {
    Arabic: {
      name: 'ريكي للأطفال',
      duration: '٤٥ دقيقة',
      price: '€65',
      description: 'جلسة ريكي مخصصة للأطفال بأساليب رقيقة لدعم النمو العاطفي والجسدي والرفاهية.'
    },
    Russian: {
      name: 'Рейки для детей',
      duration: '45 минут',
      price: '€65',
      description: 'Специальное Рейки-исцеление для детей, использующее мягкие техники для поддержки роста и благополучия.'
    },
    German: {
      name: 'Kinder-Reiki',
      duration: '45 Minuten',
      price: '€65',
      description: 'Spezielle Reiki-Sitzung für Kinder mit sanften Methoden zur Unterstützung des emotionalen und körperlichen Wachstums und Wohlbefindens.'
    },
    French: {
      name: 'Reiki pour Enfants',
      duration: '45 minutes',
      price: '€65',
      description: 'Guérison Reiki spécialisée conçue pour les enfants, utilisant des techniques douces pour soutenir leur croissance, leur développement et leur bien-être général.'
    }
  },
  'Mental & Psychic Support Session': {
    Arabic: {
      name: 'جلسة دعم ذهني وروحي',
      duration: 'ساعة',
      price: '€70',
      description: 'دعم شامل للوضوح الذهني والنمو الروحي والحماية من خلال العمل الطاقي والإرشاد الحدسي.'
    },
    Russian: {
      name: 'Сеанс ментальной и психической поддержки',
      duration: '1 час',
      price: '€70',
      description: 'Комплексная поддержка для ясности ума, психического развития и духовной защиты через энергетику и интуицию.'
    },
    German: {
      name: 'Mentale & psychische Unterstützungssitzung',
      duration: '1 Stunde',
      price: '€70',
      description: 'Umfassende Unterstützung für mentale Klarheit, spirituelles Wachstum und Schutz durch Energiearbeit und intuitive Führung.'
    },
    French: {
      name: 'Séance de Soutien Mental et Psychique',
      duration: '1 heure',
      price: '€70',
      description: 'Soutien complet pour la clarté mentale, le développement psychique et la protection spirituelle grâce au travail énergétique guidé et à la guidance intuitive.'
    }
  },
  'Timeline Therapy (Guided On-Call Session)': {
    Arabic: {
      name: 'علاج الخط الزمني (جلسة موجهة)',
      duration: 'ساعة',
      price: '€70',
      description: 'اعمل مع الماضي والمستقبل عبر خطك الزمني لإطلاق الأنماط القديمة وفتح إمكانيات جديدة.'
    },
    Russian: {
      name: 'Терапия временной линии (направляемая сессия)',
      duration: '1 час',
      price: '€70',
      description: 'Прорабатывайте травмы прошлого и тревоги будущего, исцеляя личную временную линию для роста.'
    },
    German: {
      name: 'Timeline-Therapie (Geführte Sitzung auf Abruf)',
      duration: '1 Stunde',
      price: '€70',
      description: 'Arbeite mit Vergangenheit und Zukunft entlang deiner Zeitlinie, um alte Muster zu lösen und neue Möglichkeiten zu öffnen.'
    },
    French: {
      name: 'Thérapie de la Ligne Temporelle (Séance Guidée sur Appel)',
      duration: '1 heure',
      price: '€70',
      description: 'Travaillez sur les traumatismes du passé et les anxiétés du futur en accédant et en guérissant votre ligne temporelle personnelle avec un accompagnement guidé. Cette séance puissante aide à libérer les schémas et créer de nouvelles possibilités.'
    }
  },
  'Inner Child Healing (Guided On-Call Session)': {
    Arabic: {
      name: 'شفاء الطفل الداخلي (جلسة موجهة)',
      duration: 'ساعة',
      price: '€50',
      description: 'تواصل مع طفلك الداخلي بلطف لتحرير الجراح، واستعادة الفرح والصدق في التعبير.'
    },
    Russian: {
      name: 'Исцеление внутреннего ребенка (направляемая сессия)',
      duration: '1 час',
      price: '€50',
      description: 'Исцеляйте внутреннего ребенка через сострадательное руководство, освобождая старые раны.'
    },
    German: {
      name: 'Inneres-Kind-Heilung (Geführte Sitzung auf Abruf)',
      duration: '1 Stunde',
      price: '€50',
      description: 'Verbinde dich sanft mit deinem inneren Kind, um Wunden zu lösen und Freude und Authentizität im Ausdruck wiederherzustellen.'
    }
  },
  'Plumeria Meditation (Guided On-Call Session)': {
    Arabic: {
      name: 'تأمل بلوميريا (جلسة موجهة)',
      duration: '٣٠ دقيقة',
      price: '€30',
      description: 'تأمل موجه يستعمل طاقة زهور البلوميريا للصفاء، التجديد، والارتباط الروحي.'
    },
    Russian: {
      name: 'Медитация плюмерии (направляемая сессия)',
      duration: '30 минут',
      price: '€30',
      description: 'Уникальная медитация с энергией плюмерии для глубокого расслабления и обновления.'
    },
    German: {
      name: 'Plumeria-Meditation (Geführte Sitzung auf Abruf)',
      duration: '30 Minuten',
      price: '€30',
      description: 'Geführte Meditation, die die Energie der Plumeria-Blüten für Klarheit, Erneuerung und spirituelle Verbindung nutzt.'
    },
    French: {
      name: 'Méditation Plumeria (Séance Guidée sur Appel)',
      duration: '30 minutes',
      price: '€30',
      description: 'Vivez un voyage de méditation guidée unique utilisant l\'énergie guérisseuse des fleurs de plumeria pour une relaxation profonde, le renouvellement et la connexion spirituelle.'
    }
  },
  'Message to Past / Future Self (Guided On-Call Session)': {
    Arabic: {
      name: 'رسالة إلى ذاتك الماضية/المستقبلية',
      duration: 'ساعة',
      price: '€55',
      description: 'تواصل عبر الزمن مع ذاتك للحصول على الشفاء، الحكمة، والإرشاد.'
    },
    Russian: {
      name: 'Сообщение своему прошлому/будущему Я',
      duration: '1 час',
      price: '€55',
      description: 'Свяжитесь с прошлым или будущим "я", чтобы получить исцеление и мудрость.'
    },
    German: {
      name: 'Nachricht an vergangenes/zukünftiges Selbst (Geführte Sitzung auf Abruf)',
      duration: '1 Stunde',
      price: '€55',
      description: 'Kommuniziere über die Zeit hinweg mit deinem Selbst, um Heilung, Weisheit und Führung zu erhalten.'
    },
    French: {
      name: 'Message au Soi Passé / Futur (Séance Guidée sur Appel)',
      duration: '1 heure',
      price: '€55',
      description: 'Connectez-vous avec votre soi passé ou futur grâce à une méditation guidée pour recevoir sagesse, guérison et guidance. Cette séance transformatrice fait le pont entre le temps et la conscience.'
    }
  },
  'Soul Communication (Human or Animal – Living / Past / Future)': {
    Arabic: {
      name: 'تواصل الروح (بشر أو حيوانات)',
      duration: 'ساعة',
      price: '€70',
      description: 'تيسير اتصال مع الأرواح الحية أو المنتهية أو القادمة، بما في ذلك الحيوانات، عبر جلسات عبر الإنترنت أو صوتية.'
    },
    Russian: {
      name: 'Связь с душой (человек или животное)',
      duration: '1 час',
      price: '€70',
      description: 'Общение с душами живых, ушедших или будущих, включая питомцев; доступно в онлайн-режиме или голосовом формате.'
    },
    German: {
      name: 'Seelenkommunikation (Mensch oder Tier – Lebendig / Vergangenheit / Zukunft)',
      duration: '1 Stunde',
      price: '€70',
      description: 'Vermittlung einer Verbindung mit Seelen der Lebenden, Verstorbenen oder Zukünftigen, einschließlich Tieren, über Online- oder Sprachsitzungen.'
    }
  },
  'Protection Shield': {
    Arabic: {
      name: 'درع الحماية',
      duration: '٤٥ دقيقة',
      price: '€50',
      description: 'أنشئ درعاً طاقياً قوياً حول هالتك لحمايتك من الطاقات السلبية.'
    },
    Russian: {
      name: 'Щит защиты',
      duration: '45 минут',
      price: '€50',
      description: 'Создайте мощный энергетический щит, отражающий негатив и укрепляющий ауру.'
    },
    German: {
      name: 'Schutzschild',
      duration: '45 Minuten',
      price: '€50',
      description: 'Erstelle ein kraftvolles energetisches Schutzschild um deine Aura, um dich vor negativen Energien zu schützen.'
    }
  },
  'Reflection Mirror Shield': {
    Arabic: {
      name: 'درع المرآة العاكسة',
      duration: 'ساعة',
      price: '€100',
      description: 'درع يعيد الطاقة السلبية إلى مصدرها بينما يحافظ على حمايتك.'
    },
    Russian: {
      name: 'Отражающий зеркальный щит',
      duration: '1 час',
      price: '€100',
      description: 'Создайте отражающий щит, возвращающий негатив отправителю, защищая ваше поле.'
    },
    German: {
      name: 'Spiegelreflexionsschild',
      duration: '1 Stunde',
      price: '€100',
      description: 'Ein Schild, das negative Energie zu ihrer Quelle zurückleitet und gleichzeitig deinen Schutz aufrechterhält.'
    },
    French: {
      name: 'Bouclier Miroir Réfléchissant',
      duration: '1 heure',
      price: '€100',
      description: 'Établissez un bouclier énergétique réfléchissant qui renvoie l\'énergie négative à sa source tout en protégeant votre propre champ énergétique. Une technique de protection puissante et avancée.'
    }
  },
  'Grounding Session': {
    Arabic: {
      name: 'جلسة التأصيل',
      duration: '٣٠ دقيقة',
      price: '€30',
      description: 'تأصيل عميق مع طاقة الأرض لتعزيز الاستقرار، الأمان، والحضور.'
    },
    Russian: {
      name: 'Сессия заземления',
      duration: '30 минут',
      price: '€30',
      description: 'Глубокое соединение с энергией Земли для устойчивости и присутствия.'
    },
    German: {
      name: 'Erdungssitzung',
      duration: '30 Minuten',
      price: '€30',
      description: 'Tiefe Erdung mit der Energie der Erde zur Förderung von Stabilität, Sicherheit und Präsenz.'
    }
  },
  'Manifestation Session': {
    Arabic: {
      name: 'جلسة التجلي',
      duration: 'ساعة',
      price: '€65',
      description: 'موائمة طاقتك مع نواياك، إزالة الحواجز، وتكبير قوتك لجذب ما ترغب به.'
    },
    Russian: {
      name: 'Сессия манифестации',
      duration: '1 час',
      price: '€65',
      description: 'Настройте энергию на желания, устраните блокировки и усилите творческую силу притяжения.'
    },
    German: {
      name: 'Manifestationssitzung',
      duration: '1 Stunde',
      price: '€65',
      description: 'Stimme deine Energie auf deine Absichten ab, entferne Hindernisse und verstärke deine Kraft, um anzuziehen, was du dir wünschst.'
    },
    French: {
      name: 'Séance de Manifestation',
      duration: '1 heure',
      price: '€65',
      description: 'Alignez votre énergie avec vos désirs et intentions, éliminez les blocages à la manifestation et amplifiez votre pouvoir créatif. Cette séance vous aide à attirer ce que vous désirez vraiment.'
    }
  },
  'Connecting to Ancestors & Blessing Session': {
    Arabic: {
      name: 'الاتصال بالأجداد وجلسة البركات',
      duration: '٤٠ دقيقة',
      price: '€40',
      description: 'تواصل مع سلالة أسلافك لتلقي البركات والحكمة.'
    },
    Russian: {
      name: 'Связь с предками и благословения',
      duration: '40 минут',
      price: '€40',
      description: 'Почтение предков и связь с ними за мудростью и благословениями.'
    },
    German: {
      name: 'Verbindung mit Ahnen & Segenssitzung',
      duration: '40 Minuten',
      price: '€40',
      description: 'Verbinde dich mit deiner Ahnenlinie, um Segen und Weisheit zu empfangen.'
    },
    French: {
      name: 'Connexion aux Ancêtres et Séance de Bénédictions',
      duration: '40 minutes',
      price: '€40',
      description: 'Honorez et connectez-vous avec votre lignée ancestrale pour recevoir bénédictions et sagesse.'
    }
  },
  'Opening Abundance Portal': {
    Arabic: {
      name: 'فتح بوابة الوفرة',
      duration: '٤٠ دقيقة',
      price: '€45',
      description: 'تنشيط بوابات طاقية للوفرة، إزالة المعتقدات المحدودة ودعوة الرزق.'
    },
    Russian: {
      name: 'Открытие портала изобилия',
      duration: '40 минут',
      price: '€45',
      description: 'Активация энергетических порталов изобилия, очищение ограничивающих убеждений и приглашение процветания.'
    },
    German: {
      name: 'Öffnung des Fülleportals',
      duration: '40 Minuten',
      price: '€45',
      description: 'Aktivierung energetischer Portale für Fülle, Entfernung einschränkender Glaubenssätze und Einladung von Wohlstand.'
    }
  },
  'Violet Flame Attunement': {
    Arabic: {
      name: 'ضبط شعلة البنفسج',
      duration: 'ساعة',
      price: '€150',
      description: 'التحول من خلال الوعي. مسار لطيف للتجديد الطاقي. حيث يلتقي التحرر مع الوضوح.'
    },
    Russian: {
      name: 'Настройка фиолетового пламени',
      duration: '1 час',
      price: '€150',
      description: 'Трансмутация через осознание. Мягкий путь энергетического обновления. Где освобождение встречается с ясностью.'
    },
    German: {
      name: 'Violettflammen-Abstimmung',
      duration: '1 Stunde',
      price: '€150',
      description: 'Transmutation durch Bewusstsein. Ein sanfter Weg zur energetischen Erneuerung. Wo Befreiung auf Klarheit trifft.'
    }
  },
  'Online Energy Scanning': {
    Arabic: {
      name: 'الفحص الطاقي عبر الإنترنت',
      duration: '٣٠ دقيقة',
      price: '€30',
      description: 'جلسة مسح طاقي قصيرة مدتها ٣٠ دقيقة لتحديد العوائق والمناطق التي تحتاج اهتمامًا في جسدك، مجال طاقتك، وشاكراتك.'
    },
    Russian: {
      name: 'Онлайн-энергетическое сканирование',
      duration: '30 минут',
      price: '€30',
      description: 'Краткая 30-минутная сессия энергетического сканирования для выявления блоков и областей, требующих внимания в теле, энергетическом поле и чакрах.'
    },
    German: {
      name: 'Online-Energiescanning',
      duration: '30 Minuten',
      price: '€30',
      description: 'Eine kurze 30-minütige Energiescan-Sitzung zur Identifizierung von Blockaden und Bereichen, die Aufmerksamkeit in deinem Körper, deinem Energiefeld und deinen Chakren benötigen.'
    },
    French: {
      name: 'Analyse Énergétique en Ligne',
      duration: '30 minutes',
      price: '€30',
      description: 'Une courte session d\'analyse énergétique de 30 minutes pour identifier les blocages et les zones nécessitant une attention dans votre corps, votre champ énergétique et vos chakras.'
    }
  },
  'DNA Repair': {
    Arabic: {
      name: 'إصلاح الحمض النووي',
      duration: 'ساعة',
      price: '€85',
      description: 'جلسة مصممة لدعم الذكاء الطبيعي للجسم والتوازن والتجديد على المستوى الخلوي. تعمل مع حقول الطاقة الدقيقة المرتبطة بأنماط الأسلاف والذاكرة العاطفية والطبعات الطاقية المخزنة في مجال الحمض النووي. الهدف هو تحرير عدم الانسجام بلطف واستعادة التماسك، مما يسمح للنظام بالعودة إلى حالته المثلى.'
    },
    Russian: {
      name: 'Восстановление ДНК',
      duration: '1 час',
      price: '€85',
      description: 'Сессия, направленная на поддержку естественного интеллекта тела, баланса и регенерации на клеточном уровне. Работает с тонкими энергетическими полями, связанными с родовыми паттернами, эмоциональной памятью и энергетическими отпечатками, хранящимися в поле ДНК. Намерение — мягко освободить дисгармонию и восстановить согласованность, позволяя системе вернуться к оптимальному состоянию.'
    },
    German: {
      name: 'DNA-Reparatur',
      duration: '1 Stunde',
      price: '€85',
      description: 'Eine Sitzung, die darauf ausgelegt ist, die natürliche Intelligenz des Körpers, das Gleichgewicht und die Regeneration auf zellulärer Ebene zu unterstützen. Arbeitet mit subtilen Energiefeldern, die mit Ahnenmustern, emotionalem Gedächtnis und energetischen Prägungen verbunden sind, die im DNA-Feld gespeichert sind. Die Absicht ist, Disharmonie sanft zu lösen und Kohärenz wiederherzustellen, sodass das System zu seinem optimalen Zustand zurückkehren kann.'
    }
  },
  'Connecting to Ancestors & Their Blessings Session': {
    Arabic: {
      name: 'الاتصال بالأجداد وجلسة بركاتهم',
      duration: '٤٠ دقيقة',
      price: '€50',
      description: 'أكرم واتصل بسلالة أسلافك، متلقياً البركات والحكمة من أولئك الذين سبقوك. جلسة مقدسة مدتها ٤٠ دقيقة.'
    },
    Russian: {
      name: 'Связь с предками и их благословения',
      duration: '40 минут',
      price: '€50',
      description: 'Почтите и соединитесь с родовой линией, получая благословения и мудрость от тех, кто был до вас. Священная 40-минутная сессия.'
    },
    German: {
      name: 'Verbindung mit Ahnen & ihre Segenssitzung',
      duration: '40 Minuten',
      price: '€50',
      description: 'Ehre und verbinde dich mit deiner Ahnenlinie und empfange Segen und Weisheit von denen, die vor dir waren. Eine heilige 40-minütige Sitzung.'
    },
    French: {
      name: 'Connexion aux Ancêtres et Séance de Leurs Bénédictions',
      duration: '40 minutes',
      price: '€50',
      description: 'Honorez et connectez-vous avec votre lignée ancestrale, recevant bénédictions et sagesse de ceux qui vous ont précédé. Une séance sacrée de 40 minutes.'
    }
  },
  'Customised Breathing session': {
    Arabic: {
      name: 'جلسة تنفس مخصصة',
      duration: '٣٠ دقيقة',
      price: '€50',
      description: 'ممارسات موجهة مصممة خصيصاً لاحتياجات ومواقف مختلفة. آمنة وطبيعية وخالية من الآثار الجانبية.'
    },
    Russian: {
      name: 'Индивидуальная дыхательная сессия',
      duration: '30 минут',
      price: '€50',
      description: 'Направляемые практики, адаптированные под различные потребности и ситуации. Безопасные, естественные и без побочных эффектов.'
    },
    German: {
      name: 'Individuelle Atemsitzung',
      duration: '30 Minuten',
      price: '€50',
      description: 'Geführte Praktiken, die speziell auf verschiedene Bedürfnisse und Situationen zugeschnitten sind. Sicher, natürlich und ohne Nebenwirkungen.'
    },
    French: {
      name: 'Séance de respiration personnalisée',
      duration: '30 minutes',
      price: '€50',
      description: 'Pratiques guidées conçues spécifiquement pour différents besoins et situations. Sûres, naturelles et sans effets secondaires.'
    }
  },
  'Energy Field Reading': {
    Arabic: {
      name: 'قراءة مجال الطاقة',
      duration: 'ساعة',
      price: '€70',
      description: 'جلسة هادئة وحدسية تساعدك على إدراك الأنماط الطاقية الدقيقة.'
    },
    Russian: {
      name: 'Чтение энергетического поля',
      duration: '1 час',
      price: '€70',
      description: 'Спокойная интуитивная сессия, помогающая осознать тонкие энергетические паттерны.'
    },
    German: {
      name: 'Energiefeld-Lesung',
      duration: '1 Stunde',
      price: '€70',
      description: 'Eine ruhige und intuitive Sitzung, die dir hilft, subtile energetische Muster wahrzunehmen.'
    }
  },
  'Reiki Energy Healing': {
    Arabic: {
      name: 'شفاء ريكي بالطاقة',
      duration: '٦٠ دقيقة',
      price: '€70',
      description: 'نهج شفاء عميق يدعم تحديد الأسباب الجذرية وإطلاق ما لم يعد يخدمك.'
    },
    Russian: {
      name: 'Энергетическое исцеление Рейки',
      duration: '60 минут',
      price: '€70',
      description: 'Глубокий подход к исцелению, помогающий выявить корневые причины и освободить то, что больше не служит вам.'
    },
    German: {
      name: 'Reiki-Energieheilung',
      duration: '60 Minuten',
      price: '€70',
      description: 'Ein tiefgreifender Heilungsansatz, der die Identifizierung von Grundursachen unterstützt und das freigibt, was dir nicht mehr dient.'
    },
    French: {
      name: 'Guérison énergétique Reiki',
      duration: '60 minutes',
      price: '€70',
      description: 'Une approche de guérison profonde qui soutient l\'identification des causes profondes et la libération de ce qui ne vous sert plus.'
    }
  },
  'Usui Reiki Course': {
    Arabic: {
      name: 'دورة ريكي أوسوي',
      duration: 'ساعة × ١٨ جلسة ودعم غير محدود عبر الإنترنت',
      price: '€3000',
      description: 'ممارسة يابانية للشفاء بالطاقة تدعم التوازن والاسترخاء والوعي الطاقي. توفر الضبط والتقنيات العملية والممارسة الموجهة في بيئة آمنة ومنظمة.'
    },
    Russian: {
      name: 'Курс Усуи Рейки',
      duration: '1 час × 18 сессий и неограниченная онлайн-поддержка',
      price: '€3000',
      description: 'Японская практика энергетического исцеления, поддерживающая баланс, расслабление и энергетическое осознание. Предоставляет настройки, практические техники и направляемую практику в безопасном и структурированном формате.'
    },
    German: {
      name: 'Usui-Reiki-Kurs',
      duration: '1 Stunde × 18 Sitzungen und unbegrenzte Online-Unterstützung',
      price: '€3000',
      description: 'Japanische Praxis der Energieheilung, die Balance, Entspannung und energetisches Bewusstsein unterstützt. Bietet Einstimmungen, praktische Techniken und geführte Praxis in einer sicheren und strukturierten Umgebung.'
    }
  },
  'Kundalini Reiki Course': {
    Arabic: {
      name: 'دورة ريكي كونداليني',
      duration: 'ساعة × ٣ جلسات ودعم غير محدود عبر الإنترنت',
      price: '€350',
      description: 'ممارسة طاقية لطيفة تدعم الاستيقاظ الطبيعي وتدفق طاقة قوة الحياة. ضبط آمن، ممارسات موجهة، وتعاليم متجذرة لدعم التوازن والوضوح والوعي الطاقي.'
    },
    Russian: {
      name: 'Курс Кундалини Рейки',
      duration: '1 час × 3 сессии и неограниченная онлайн-поддержка',
      price: '€350',
      description: 'Мягкая энергетическая практика, поддерживающая естественное пробуждение и поток жизненной силы. Безопасные настройки, направляемые практики и заземлённые учения для поддержки баланса, ясности и энергетического осознания.'
    },
    German: {
      name: 'Kundalini-Reiki-Kurs',
      duration: '1 Stunde × 3 Sitzungen und unbegrenzte Online-Unterstützung',
      price: '€350',
      description: 'Sanfte energetische Praxis, die natürliches Erwachen und den Fluss der Lebenskraft unterstützt. Sichere Einstimmungen, geführte Praktiken und geerdete Lehren zur Unterstützung von Balance, Klarheit und energetischem Bewusstsein.'
    }
  },
  'Quantum Alchemy Course': {
    Arabic: {
      name: 'دورة الكيمياء الكمية',
      duration: 'ساعة × ٢٠ جلسة',
      price: '€2500',
      description: 'رحلة واعية إلى الكيمياء الداخلية، تدعم التحول والوضوح والعيش المتوافق.'
    },
    Russian: {
      name: 'Курс квантовой алхимии',
      duration: '1 час × 20 сессий',
      price: '€2500',
      description: 'Сознательное путешествие во внутреннюю алхимию, поддерживающее трансформацию, ясность и согласованную жизнь.'
    },
    German: {
      name: 'Quantenalchemie-Kurs',
      duration: '1 Stunde × 20 Sitzungen',
      price: '€2500',
      description: 'Eine bewusste Reise in die innere Alchemie, die Transformation, Klarheit und ein kohärentes Leben unterstützt.'
    }
  },
  'Kahuna Master Course': {
    Arabic: {
      name: 'دورة كاهونا المتقدمة',
      duration: 'ساعة × ٤٠ جلسة ودعم غير محدود عبر الإنترنت',
      price: '€4500',
      description: 'دورة روحية متقدمة مستوحاة من حكمة كاهونا، تركز على الوعي الطاقي، النية، التوازن، وإتقان الذات الواعي.'
    },
    Russian: {
      name: 'Мастер-курс Кахуна',
      duration: '1 час × 40 сессий и неограниченная онлайн-поддержка',
      price: '€4500',
      description: 'Продвинутый духовный курс, вдохновлённый мудростью Кахуна, сфокусированный на энергетическом осознании, намерении, балансе и сознательном самообладании.'
    },
    German: {
      name: 'Kahuna-Meisterkurs',
      duration: '1 Stunde × 40 Sitzungen und unbegrenzte Online-Unterstützung',
      price: '€4500',
      description: 'Ein fortgeschrittener spiritueller Kurs, inspiriert von der Weisheit der Kahuna, der sich auf energetisches Bewusstsein, Absicht, Balance und bewusste Selbstbeherrschung konzentriert.'
    }
  }
};

export const translateService = (service, language) => {
  // Always preserve the original price - never translate it
  const originalPrice = service.price;
  
  // First, check if service has database translations (priority)
  if (language === 'Arabic') {
    if (service.name_ar || service.description_ar || service.duration_ar) {
      return {
        ...service,
        name: service.name_ar || service.name,
        description: service.description_ar || service.description,
        duration: service.duration_ar || service.duration,
        price: originalPrice // Always keep original price
      };
    }
  } else if (language === 'Russian') {
    if (service.name_ru || service.description_ru || service.duration_ru) {
      return {
        ...service,
        name: service.name_ru || service.name,
        description: service.description_ru || service.description,
        duration: service.duration_ru || service.duration,
        price: originalPrice // Always keep original price
      };
    }
  } else if (language === 'German') {
    if (service.name_de || service.description_de || service.duration_de) {
      return {
        ...service,
        name: service.name_de || service.name,
        description: service.description_de || service.description,
        duration: service.duration_de || service.duration,
        price: originalPrice // Always keep original price
      };
    }
  } else if (language === 'French') {
    if (service.name_fr || service.description_fr || service.duration_fr) {
      return {
        ...service,
        name: service.name_fr || service.name,
        description: service.description_fr || service.description,
        duration: service.duration_fr || service.duration,
        price: originalPrice // Always keep original price
      };
    }
  }
  
  // Fallback to file-based translations if database translations don't exist
  const translation = serviceTranslations[service.name];
  if (!translation) return service;
  const localized = translation[language];
  if (localized) {
    // Remove price from localized object if it exists, then merge and restore original price
    const { price, ...localizedWithoutPrice } = localized;
    return { 
      ...service, 
      ...localizedWithoutPrice,
      price: originalPrice // Always keep original price
    };
  }
  return service;
};

export const typeTranslations = {
  Remote: {
    Arabic: 'عن بعد',
    Russian: 'Удалённо',
    German: 'Fern',
    French: 'À Distance'
  },
  'On-Call': {
    Arabic: 'عند الطلب',
    Russian: 'По вызову',
    German: 'Auf Abruf',
    French: 'Sur Appel'
  }
};

export const myBookingsPageCopy = {
  English: {
    pageTitle: 'My Bookings',
    filters: {
      Upcoming: 'Upcoming',
      'Pending Confirmation': 'Pending Confirmation',
      Completed: 'Completed'
    },
    loading: 'Loading your bookings...',
    error: 'Failed to load bookings. Please try again.',
    tryAgain: 'Try Again',
    detailLabels: {
      type: 'Type',
      date: 'Date',
      time: 'Time',
      duration: 'Duration'
    },
    viewDetails: 'View Details',
    joinSession: 'Join Session',
    emptyTitle: 'No Bookings Found',
    empty: {
      Upcoming: "You don't have any upcoming bookings at the moment.",
      'Pending Confirmation': "You don't have any pending bookings.",
      Completed: "You don't have any completed bookings yet."
    },
    exploreServices: 'Explore Services',
    notificationsHint: 'Booking updates and reminders will appear in your notifications.',
    loginPrompt: 'Please login to view your bookings.'
  },
  Arabic: {
    pageTitle: 'حجوزاتي',
    filters: {
      Upcoming: 'القادمة',
      'Pending Confirmation': 'بانتظار التأكيد',
      Completed: 'المكتملة'
    },
    loading: 'جاري تحميل الحجوزات...',
    error: 'فشل في تحميل الحجوزات. يرجى المحاولة مرة أخرى.',
    tryAgain: 'حاول مرة أخرى',
    detailLabels: {
      type: 'النوع',
      date: 'التاريخ',
      time: 'الوقت',
      duration: 'المدة'
    },
    viewDetails: 'عرض التفاصيل',
    joinSession: 'انضم إلى الجلسة',
    emptyTitle: 'لا توجد حجوزات',
    empty: {
      Upcoming: 'لا تملك أي حجوزات قادمة حالياً.',
      'Pending Confirmation': 'لا توجد حجوزات بانتظار التأكيد.',
      Completed: 'لم تُكمل أي حجوزات بعد.'
    },
    exploreServices: 'استكشف الخدمات',
    notificationsHint: 'ستظهر تحديثات الحجوزات والتذكيرات في إشعاراتك.',
    loginPrompt: 'الرجاء تسجيل الدخول لعرض الحجوزات.'
  },
  Russian: {
    pageTitle: 'Мои бронирования',
    filters: {
      Upcoming: 'Будущие',
      'Pending Confirmation': 'Ожидают подтверждения',
      Completed: 'Завершённые'
    },
    loading: 'Загрузка ваших бронирований...',
    error: 'Не удалось загрузить бронирования. Попробуйте снова.',
    tryAgain: 'Попробовать снова',
    detailLabels: {
      type: 'Тип',
      date: 'Дата',
      time: 'Время',
      duration: 'Длительность'
    },
    viewDetails: 'Подробнее',
    joinSession: 'Присоединиться',
    emptyTitle: 'Бронирования не найдены',
    empty: {
      Upcoming: 'У вас нет предстоящих бронирований.',
      'Pending Confirmation': 'У вас нет бронирований в ожидании.',
      Completed: 'Пока нет завершённых бронирований.'
    },
    exploreServices: 'Изучить услуги',
    notificationsHint: 'Обновления и напоминания по бронированиям будут приходить в уведомления.',
    loginPrompt: 'Пожалуйста, войдите, чтобы просмотреть бронирования.'
  },
  German: {
    pageTitle: 'Meine Buchungen',
    filters: {
      Upcoming: 'Bevorstehend',
      'Pending Confirmation': 'Ausstehende Bestätigung',
      Completed: 'Abgeschlossen'
    },
    loading: 'Deine Buchungen werden geladen...',
    error: 'Buchungen konnten nicht geladen werden. Bitte versuche es erneut.',
    tryAgain: 'Erneut versuchen',
    detailLabels: {
      type: 'Typ',
      date: 'Datum',
      time: 'Uhrzeit',
      duration: 'Dauer'
    },
    viewDetails: 'Details anzeigen',
    joinSession: 'Sitzung beitreten',
    emptyTitle: 'Keine Buchungen gefunden',
    empty: {
      Upcoming: 'Du hast derzeit keine bevorstehenden Buchungen.',
      'Pending Confirmation': 'Du hast keine ausstehenden Buchungen.',
      Completed: 'Du hast noch keine abgeschlossenen Buchungen.'
    },
    exploreServices: 'Dienste erkunden',
    notificationsHint: 'Buchungsaktualisierungen und Erinnerungen erscheinen in deinen Benachrichtigungen.',
    loginPrompt: 'Bitte melde dich an, um deine Buchungen anzuzeigen.'
  },
  French: {
    pageTitle: 'Mes Réservations',
    filters: {
      Upcoming: 'À Venir',
      'Pending Confirmation': 'En Attente de Confirmation',
      Completed: 'Terminées'
    },
    loading: 'Chargement de vos réservations...',
    error: 'Échec du chargement des réservations. Veuillez réessayer.',
    tryAgain: 'Réessayer',
    detailLabels: {
      type: 'Type',
      date: 'Date',
      time: 'Heure',
      duration: 'Durée'
    },
    viewDetails: 'Voir les Détails',
    joinSession: 'Rejoindre la Séance',
    emptyTitle: 'Aucune Réservation Trouvée',
    empty: {
      Upcoming: 'Vous n\'avez aucune réservation à venir pour le moment.',
      'Pending Confirmation': 'Vous n\'avez aucune réservation en attente.',
      Completed: 'Vous n\'avez pas encore de réservations terminées.'
    },
    exploreServices: 'Explorer les Services',
    notificationsHint: 'Les mises à jour et rappels de réservation apparaîtront dans vos notifications.',
    loginPrompt: 'Veuillez vous connecter pour voir vos réservations.'
  }
};

export const profilePageCopy = {
  English: {
    pageTitle: 'My Profile',
    nameLabel: 'Name',
    emailLabel: 'Email',
    logoutButton: 'Logout',
    deleteAccountButton: 'Delete Account',
    deleting: 'Deleting...',
    loadingProfile: 'Loading profile...',
    deleteModalTitle: 'Delete Account',
    deleteModalMessage: 'Are you sure you want to delete your account? This action cannot be undone.',
    deleteModalWarning: 'You will not be able to login again.',
    cancelButton: 'Cancel',
    confirmDeleteButton: 'Yes, Delete Account',
    deleteError: 'Unable to determine your account. Please try again later.',
    deleteSuccess: 'Your account has been deleted successfully. You will not be able to login again.',
    deleteFailed: 'Failed to delete account. Please try again.'
  },
  Arabic: {
    pageTitle: 'ملفي الشخصي',
    nameLabel: 'الاسم',
    emailLabel: 'البريد الإلكتروني',
    logoutButton: 'تسجيل الخروج',
    deleteAccountButton: 'حذف الحساب',
    deleting: 'جاري الحذف...',
    loadingProfile: 'جاري تحميل الملف الشخصي...',
    deleteModalTitle: 'حذف الحساب',
    deleteModalMessage: 'هل أنت متأكد أنك تريد حذف حسابك؟ لا يمكن التراجع عن هذا الإجراء.',
    deleteModalWarning: 'لن تتمكن من تسجيل الدخول مرة أخرى.',
    cancelButton: 'إلغاء',
    confirmDeleteButton: 'نعم، احذف الحساب',
    deleteError: 'تعذر تحديد حسابك. يرجى المحاولة مرة أخرى لاحقاً.',
    deleteSuccess: 'تم حذف حسابك بنجاح. لن تتمكن من تسجيل الدخول مرة أخرى.',
    deleteFailed: 'فشل في حذف الحساب. يرجى المحاولة مرة أخرى.'
  },
  Russian: {
    pageTitle: 'Мой профиль',
    nameLabel: 'Имя',
    emailLabel: 'Электронная почта',
    logoutButton: 'Выйти',
    deleteAccountButton: 'Удалить аккаунт',
    deleting: 'Удаление...',
    loadingProfile: 'Загрузка профиля...',
    deleteModalTitle: 'Удалить аккаунт',
    deleteModalMessage: 'Вы уверены, что хотите удалить свой аккаунт? Это действие нельзя отменить.',
    deleteModalWarning: 'Вы не сможете войти снова.',
    cancelButton: 'Отмена',
    confirmDeleteButton: 'Да, удалить аккаунт',
    deleteError: 'Не удалось определить ваш аккаунт. Пожалуйста, попробуйте позже.',
    deleteSuccess: 'Ваш аккаунт успешно удален. Вы не сможете войти снова.',
    deleteFailed: 'Не удалось удалить аккаунт. Попробуйте снова.'
  },
  German: {
    pageTitle: 'Mein Profil',
    nameLabel: 'Name',
    emailLabel: 'E-Mail',
    logoutButton: 'Abmelden',
    deleteAccountButton: 'Konto löschen',
    deleting: 'Wird gelöscht...',
    loadingProfile: 'Profil wird geladen...',
    deleteModalTitle: 'Konto löschen',
    deleteModalMessage: 'Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteModalWarning: 'Sie werden sich nicht mehr anmelden können.',
    cancelButton: 'Abbrechen',
    confirmDeleteButton: 'Ja, Konto löschen',
    deleteError: 'Ihr Konto konnte nicht ermittelt werden. Bitte versuchen Sie es später erneut.',
    deleteSuccess: 'Ihr Konto wurde erfolgreich gelöscht. Sie werden sich nicht mehr anmelden können.',
    deleteFailed: 'Konto konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.'
  },
  French: {
    pageTitle: 'Mon Profil',
    nameLabel: 'Nom',
    emailLabel: 'Email',
    logoutButton: 'Déconnexion',
    deleteAccountButton: 'Supprimer le Compte',
    deleting: 'Suppression...',
    loadingProfile: 'Chargement du profil...',
    deleteModalTitle: 'Supprimer le Compte',
    deleteModalMessage: 'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action ne peut pas être annulée.',
    deleteModalWarning: 'Vous ne pourrez plus vous connecter.',
    cancelButton: 'Annuler',
    confirmDeleteButton: 'Oui, Supprimer le Compte',
    deleteError: 'Impossible de déterminer votre compte. Veuillez réessayer plus tard.',
    deleteSuccess: 'Votre compte a été supprimé avec succès. Vous ne pourrez plus vous connecter.',
    deleteFailed: 'Échec de la suppression du compte. Veuillez réessayer.'
  }
};

export const headerCopy = {
  English: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      terms: 'Terms',
      myBookings: 'My Bookings'
    },
    searchPlaceholder: 'Search services...',
    addService: 'Add New Service',
    auth: {
      login: 'Login',
      logout: 'Logout',
      signup: 'Sign Up'
    },
    mobile: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      terms: 'Terms',
      myBookings: 'My Bookings',
      profile: 'Profile'
    }
  },
  Arabic: {
    nav: {
      home: 'الرئيسية',
      services: 'الخدمات',
      about: 'من نحن',
      terms: 'الشروط',
      myBookings: 'حجوزاتي'
    },
    searchPlaceholder: 'ابحث في الخدمات...',
    addService: 'أضف خدمة جديدة',
    auth: {
      login: 'تسجيل الدخول',
      logout: 'تسجيل الخروج',
      signup: 'إنشاء حساب'
    },
    mobile: {
      home: 'الرئيسية',
      services: 'الخدمات',
      about: 'من نحن',
      terms: 'الشروط',
      myBookings: 'حجوزاتي',
      profile: 'الملف الشخصي'
    }
  },
  Russian: {
    nav: {
      home: 'Главная',
      services: 'Услуги',
      about: 'О нас',
      terms: 'Условия',
      myBookings: 'Мои бронирования'
    },
    searchPlaceholder: 'Ищите услуги...',
    addService: 'Добавить услугу',
    auth: {
      login: 'Войти',
      logout: 'Выйти',
      signup: 'Регистрация'
    },
    mobile: {
      home: 'Главная',
      services: 'Услуги',
      about: 'О нас',
      terms: 'Условия',
      myBookings: 'Бронирования',
      profile: 'Профиль'
    }
  },
  German: {
    nav: {
      home: 'Startseite',
      services: 'Dienste',
      about: 'Über uns',
      terms: 'Bedingungen',
      myBookings: 'Meine Buchungen'
    },
    searchPlaceholder: 'Dienste suchen...',
    addService: 'Neuen Dienst hinzufügen',
    auth: {
      login: 'Anmelden',
      logout: 'Abmelden',
      signup: 'Registrieren'
    },
    mobile: {
      home: 'Startseite',
      services: 'Dienste',
      about: 'Über uns',
      terms: 'Bedingungen',
      myBookings: 'Meine Buchungen',
      profile: 'Profil'
    }
  }
};

export const signupPageCopy = {
  English: {
    title: 'Create Account',
    subtitle: 'Begin your journey toward balance and healing',
    fullNamePlaceholder: 'Full Name',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Password',
    confirmPasswordPlaceholder: 'Confirm Password',
    signupButton: 'Create Account',
    creating: 'Creating Account...',
    alternateText: 'Already have an account?',
    login: 'Login',
    privacyNote: 'We respect your privacy. Your data is safe.',
    successMessage: 'Account created successfully! Please login.',
    errors: {
      fullNameRequired: 'Full name is required',
      emailRequired: 'Email is required',
      emailInvalid: 'Email is invalid',
      passwordRequired: 'Password is required',
      passwordLength: 'Password must be at least 8 characters',
      confirmPasswordRequired: 'Please confirm your password',
      passwordsMismatch: 'Passwords do not match',
      emailExists: 'This email is already registered',
      dbConnection: 'Database connection error. Please refresh the page.',
      signupFailed: 'Failed to create account. Please try again.',
      unexpected: 'An unexpected error occurred. Please try again.'
    }
  },
  Arabic: {
    title: 'إنشاء حساب',
    subtitle: 'ابدأ رحلتك نحو التوازن والشفاء',
    fullNamePlaceholder: 'الاسم الكامل',
    emailPlaceholder: 'البريد الإلكتروني',
    passwordPlaceholder: 'كلمة المرور',
    confirmPasswordPlaceholder: 'تأكيد كلمة المرور',
    signupButton: 'إنشاء حساب',
    creating: 'جاري إنشاء الحساب...',
    alternateText: 'هل لديك حساب؟',
    login: 'تسجيل الدخول',
    privacyNote: 'نحترم خصوصيتك. بياناتك آمنة.',
    successMessage: 'تم إنشاء الحساب بنجاح! يرجى تسجيل الدخول.',
    errors: {
      fullNameRequired: 'الاسم الكامل مطلوب',
      emailRequired: 'البريد الإلكتروني مطلوب',
      emailInvalid: 'البريد الإلكتروني غير صالح',
      passwordRequired: 'كلمة المرور مطلوبة',
      passwordLength: 'يجب أن تتكون كلمة المرور من ٨ أحرف على الأقل',
      confirmPasswordRequired: 'يرجى تأكيد كلمة المرور',
      passwordsMismatch: 'كلمتا المرور غير متطابقتين',
      emailExists: 'هذا البريد مسجل بالفعل',
      dbConnection: 'خطأ في الاتصال بقاعدة البيانات. يرجى تحديث الصفحة.',
      signupFailed: 'فشل في إنشاء الحساب. يرجى المحاولة مرة أخرى.',
      unexpected: 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.'
    }
  },
  Russian: {
    title: 'Создать аккаунт',
    subtitle: 'Начните путь к балансу и исцелению',
    fullNamePlaceholder: 'Полное имя',
    emailPlaceholder: 'Электронная почта',
    passwordPlaceholder: 'Пароль',
    confirmPasswordPlaceholder: 'Подтвердите пароль',
    signupButton: 'Создать аккаунт',
    creating: 'Создание аккаунта...',
    alternateText: 'Уже есть аккаунт?',
    login: 'Войти',
    privacyNote: 'Мы уважаем вашу приватность. Ваши данные в безопасности.',
    successMessage: 'Аккаунт успешно создан! Пожалуйста, войдите.',
    errors: {
      fullNameRequired: 'Требуется полное имя',
      emailRequired: 'Требуется электронная почта',
      emailInvalid: 'Электронная почта недействительна',
      passwordRequired: 'Требуется пароль',
      passwordLength: 'Пароль должен содержать не менее 8 символов',
      confirmPasswordRequired: 'Подтвердите пароль',
      passwordsMismatch: 'Пароли не совпадают',
      emailExists: 'Этот адрес уже зарегистрирован',
      dbConnection: 'Ошибка подключения к базе данных. Обновите страницу.',
      signupFailed: 'Не удалось создать аккаунт. Попробуйте снова.',
      unexpected: 'Произошла ошибка. Попробуйте снова.'
    }
  },
  German: {
    title: 'Konto erstellen',
    subtitle: 'Beginne deine Reise zu Balance und Heilung',
    fullNamePlaceholder: 'Vollständiger Name',
    emailPlaceholder: 'E-Mail',
    passwordPlaceholder: 'Passwort',
    confirmPasswordPlaceholder: 'Passwort bestätigen',
    signupButton: 'Konto erstellen',
    creating: 'Konto wird erstellt...',
    alternateText: 'Bereits ein Konto?',
    login: 'Anmelden',
    privacyNote: 'Wir respektieren deine Privatsphäre. Deine Daten sind sicher.',
    successMessage: 'Konto erfolgreich erstellt! Bitte melde dich an.',
    errors: {
      fullNameRequired: 'Vollständiger Name ist erforderlich',
      emailRequired: 'E-Mail ist erforderlich',
      emailInvalid: 'E-Mail ist ungültig',
      passwordRequired: 'Passwort ist erforderlich',
      passwordLength: 'Passwort muss mindestens 8 Zeichen lang sein',
      confirmPasswordRequired: 'Bitte bestätige dein Passwort',
      passwordsMismatch: 'Passwörter stimmen nicht überein',
      emailExists: 'Diese E-Mail ist bereits registriert',
      dbConnection: 'Datenbankverbindungsfehler. Bitte aktualisiere die Seite.',
      signupFailed: 'Konto konnte nicht erstellt werden. Bitte versuche es erneut.',
      unexpected: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.'
    }
  },
  French: {
    title: 'Créer un Compte',
    subtitle: 'Commencez votre voyage vers l\'équilibre et la guérison',
    fullNamePlaceholder: 'Nom complet',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Mot de passe',
    confirmPasswordPlaceholder: 'Confirmer le mot de passe',
    signupButton: 'Créer un Compte',
    creating: 'Création du compte...',
    alternateText: 'Vous avez déjà un compte ?',
    login: 'Se connecter',
    privacyNote: 'Nous respectons votre vie privée. Vos données sont sécurisées.',
    successMessage: 'Compte créé avec succès ! Veuillez vous connecter.',
    errors: {
      fullNameRequired: 'Le nom complet est requis',
      emailRequired: 'L\'email est requis',
      emailInvalid: 'L\'email n\'est pas valide',
      passwordRequired: 'Le mot de passe est requis',
      passwordLength: 'Le mot de passe doit contenir au moins 8 caractères',
      confirmPasswordRequired: 'Veuillez confirmer votre mot de passe',
      passwordsMismatch: 'Les mots de passe ne correspondent pas',
      emailExists: 'Cet email est déjà enregistré',
      dbConnection: 'Erreur de connexion à la base de données. Veuillez actualiser la page.',
      signupFailed: 'Échec de la création du compte. Veuillez réessayer.',
      unexpected: 'Une erreur inattendue s\'est produite. Veuillez réessayer.'
    }
  }
};

export const termsAndConditionsCopy = {
  English: {
    title: 'Terms and Conditions – Online Reiki Healing Sessions',
    intro: 'By submitting an application and/or booking an online Reiki healing session, you acknowledge that you have read, understood, and agreed to the following Terms and Conditions.',
    section1: {
      title: 'Nature of Reiki Healing',
      content: 'Reiki is a complementary energy healing practice intended to support relaxation, balance, and overall well-being. Reiki sessions are not a substitute for medical care, psychological treatment, or professional healthcare advice.',
      content2: 'Reiki practitioners do not diagnose, treat, cure, or prescribe for any medical or mental health conditions.'
    },
    section2: {
      title: 'Client Responsibility',
      content: 'By participating in a Reiki healing session, you confirm that:',
      item1: 'You take full responsibility for your own physical, emotional, mental, and spiritual well-being.',
      item2: 'You understand that results vary from person to person.',
      item3: 'You agree to seek appropriate medical or professional help for any health-related concerns.'
    },
    section3: {
      title: 'No Medical Claims',
      content: 'Reiki healing is not intended to replace:',
      item1: 'Medical treatment',
      item2: 'Psychiatric or psychological therapy',
      item3: 'Advice from licensed healthcare professionals',
      content2: 'Always consult a qualified healthcare provider regarding any medical condition.'
    },
    section4: {
      title: 'Online / Distance Sessions',
      content: 'For online or distance Reiki sessions:',
      item1: 'Sessions are conducted energetically and do not require physical touch.',
      item2: 'Stable internet access and a quiet environment are recommended.',
      item3: 'The practitioner is not responsible for technical issues beyond their control.'
    },
    section5: {
      title: 'Confidentiality',
      content: 'All personal information shared during the application process and sessions is treated as confidential and will not be shared with third parties, except where required by law.'
    },
    section6: {
      title: 'Session Experience',
      content: 'Clients may experience sensations such as relaxation, warmth, emotional release, or tiredness. These experiences are normal and vary individually. No specific outcome is guaranteed.'
    },
    section7: {
      title: 'Consent',
      content: 'By booking a session, you confirm that:',
      item1: 'You voluntarily choose to receive Reiki healing.',
      item2: 'You give informed consent to participate.',
      item3: 'You may stop the session at any time.'
    },
    section8: {
      title: 'Payment & Refund Policy',
      content: '',
      item1: 'Full payment is required to confirm a booking (unless otherwise stated).',
      item2: 'Missed sessions or late cancellations may not be refundable.',
      item3: 'Refunds are not guaranteed once a session has been delivered.'
    },
    section9: {
      title: "Practitioner's Right",
      content: 'The practitioner reserves the right to:',
      item1: 'Refuse or discontinue a session if it is deemed inappropriate.',
      item2: 'End a session if respectful boundaries are not maintained.'
    },
    section10: {
      title: 'Acceptance of Terms',
      content: 'By submitting the application form and/or booking a Reiki session, you confirm that you have read, understood, and accepted these Terms and Conditions.'
    },
    section11: {
      title: 'Privacy Information',
      content: 'We Do NOT collect personal information - to book a session require only first (real) name. No other information is required.'
    },
    backHome: 'Back to Home'
  },
  Arabic: {
    title: 'الشروط والأحكام – جلسات الريكي العلاجية عبر الإنترنت',
    intro: 'من خلال تقديم طلب و/أو حجز جلسة ريكي علاجية عبر الإنترنت، فإنك تقر بأنك قد قرأت وفهمت ووافقت على الشروط والأحكام التالية.',
    section1: {
      title: 'طبيعة علاج الريكي',
      content: 'الريكي هو ممارسة علاجية طاقية تكميلية تهدف إلى دعم الاسترخاء والتوازن والرفاهية العامة. جلسات الريكي ليست بديلاً عن الرعاية الطبية أو العلاج النفسي أو المشورة الصحية المهنية.',
      content2: 'ممارسو الريكي لا يقومون بتشخيص أو علاج أو شفاء أو وصف أي حالات طبية أو صحية عقلية.'
    },
    section2: {
      title: 'مسؤولية العميل',
      content: 'من خلال المشاركة في جلسة ريكي علاجية، فإنك تؤكد أن:',
      item1: 'أنك تتحمل المسؤولية الكاملة عن رفاهيتك الجسدية والعاطفية والعقلية والروحية.',
      item2: 'أنك تفهم أن النتائج تختلف من شخص لآخر.',
      item3: 'أنك توافق على طلب المساعدة الطبية أو المهنية المناسبة لأي مخاوف متعلقة بالصحة.'
    },
    section3: {
      title: 'لا توجد ادعاءات طبية',
      content: 'علاج الريكي ليس المقصود به أن يحل محل:',
      item1: 'العلاج الطبي',
      item2: 'العلاج النفسي أو النفسي',
      item3: 'نصائح من متخصصي الرعاية الصحية المرخصين',
      content2: 'استشر دائماً مقدم رعاية صحية مؤهل فيما يتعلق بأي حالة طبية.'
    },
    section4: {
      title: 'الجلسات عبر الإنترنت / عن بُعد',
      content: 'لجلسات الريكي عبر الإنترنت أو عن بُعد:',
      item1: 'تُجرى الجلسات بشكل طاقي ولا تتطلب لمساً جسدياً.',
      item2: 'يُنصح بالحصول على اتصال إنترنت مستقر وبيئة هادئة.',
      item3: 'الممارس غير مسؤول عن المشاكل التقنية التي خارجة عن سيطرته.'
    },
    section5: {
      title: 'السرية',
      content: 'جميع المعلومات الشخصية التي يتم مشاركتها أثناء عملية التقديم والجلسات تُعامل على أنها سرية ولن يتم مشاركتها مع أطراف ثالثة، إلا حيثما يتطلب القانون ذلك.'
    },
    section6: {
      title: 'تجربة الجلسة',
      content: 'قد يواجه العملاء أحاسيس مثل الاسترخاء والدفء والإفراج العاطفي أو التعب. هذه التجارب طبيعية وتختلف بشكل فردي. لا يتم ضمان نتيجة محددة.'
    },
    section7: {
      title: 'الموافقة',
      content: 'من خلال حجز جلسة، فإنك تؤكد أن:',
      item1: 'أنك تختار طواعية تلقي علاج الريكي.',
      item2: 'أنك تعطي موافقة مستنيرة للمشاركة.',
      item3: 'يمكنك إيقاف الجلسة في أي وقت.'
    },
    section8: {
      title: 'سياسة الدفع والاسترداد',
      content: '',
      item1: 'مطلوب الدفع الكامل لتأكيد الحجز (ما لم يُذكر خلاف ذلك).',
      item2: 'الجلسات الفائتة أو الإلغاءات المتأخرة قد لا تكون قابلة للاسترداد.',
      item3: 'لا يتم ضمان الاسترداد بمجرد تقديم الجلسة.'
    },
    section9: {
      title: 'حق الممارس',
      content: 'يحتفظ الممارس بالحق في:',
      item1: 'رفض أو إنهاء جلسة إذا اعتُبرت غير مناسبة.',
      item2: 'إنهاء جلسة إذا لم يتم الحفاظ على الحدود المحترمة.'
    },
    section10: {
      title: 'قبول الشروط',
      content: 'من خلال تقديم نموذج الطلب و/أو حجز جلسة ريكي، فإنك تؤكد أنك قد قرأت وفهمت وقبلت هذه الشروط والأحكام.'
    },
    section11: {
      title: 'معلومات الخصوصية',
      content: 'نحن لا نجمع معلومات شخصية - لحجز جلسة يتطلب فقط الاسم الأول (الحقيقي). لا توجد معلومات أخرى مطلوبة.'
    },
    backHome: 'العودة إلى الرئيسية'
  },
  Russian: {
    title: 'Условия использования – Онлайн сеансы исцеления Рейки',
    intro: 'Отправляя заявку и/или бронируя онлайн сеанс исцеления Рейки, вы подтверждаете, что прочитали, поняли и согласились со следующими Условиями использования.',
    section1: {
      title: 'Природа исцеления Рейки',
      content: 'Рейки — это дополнительная практика энергетического исцеления, предназначенная для поддержки расслабления, баланса и общего благополучия. Сеансы Рейки не являются заменой медицинской помощи, психологического лечения или профессиональных медицинских консультаций.',
      content2: 'Практикующие Рейки не диагностируют, не лечат, не излечивают и не назначают лечение при каких-либо медицинских или психических состояниях.'
    },
    section2: {
      title: 'Ответственность клиента',
      content: 'Участвуя в сеансе исцеления Рейки, вы подтверждаете, что:',
      item1: 'Вы полностью берете на себя ответственность за свое физическое, эмоциональное, психическое и духовное благополучие.',
      item2: 'Вы понимаете, что результаты варьируются от человека к человеку.',
      item3: 'Вы соглашаетесь обращаться за соответствующей медицинской или профессиональной помощью по любым вопросам, связанным со здоровьем.'
    },
    section3: {
      title: 'Отсутствие медицинских заявлений',
      content: 'Исцеление Рейки не предназначено для замены:',
      item1: 'Медицинского лечения',
      item2: 'Психиатрической или психологической терапии',
      item3: 'Консультаций лицензированных медицинских специалистов',
      content2: 'Всегда консультируйтесь с квалифицированным медицинским работником по поводу любого заболевания.'
    },
    section4: {
      title: 'Онлайн / Дистанционные сеансы',
      content: 'Для онлайн или дистанционных сеансов Рейки:',
      item1: 'Сеансы проводятся энергетически и не требуют физического контакта.',
      item2: 'Рекомендуется стабильный доступ в интернет и тихая обстановка.',
      item3: 'Практикующий не несет ответственности за технические проблемы, находящиеся вне его контроля.'
    },
    section5: {
      title: 'Конфиденциальность',
      content: 'Вся личная информация, предоставленная в процессе подачи заявки и во время сеансов, считается конфиденциальной и не будет передана третьим лицам, за исключением случаев, предусмотренных законом.'
    },
    section6: {
      title: 'Опыт сеанса',
      content: 'Клиенты могут испытывать ощущения, такие как расслабление, тепло, эмоциональное освобождение или усталость. Эти переживания нормальны и различаются индивидуально. Конкретный результат не гарантируется.'
    },
    section7: {
      title: 'Согласие',
      content: 'Бронируя сеанс, вы подтверждаете, что:',
      item1: 'Вы добровольно выбираете получение исцеления Рейки.',
      item2: 'Вы даете информированное согласие на участие.',
      item3: 'Вы можете прекратить сеанс в любое время.'
    },
    section8: {
      title: 'Политика оплаты и возврата',
      content: '',
      item1: 'Для подтверждения бронирования требуется полная оплата (если не указано иное).',
      item2: 'Пропущенные сеансы или поздние отмены могут не подлежать возврату.',
      item3: 'Возврат средств не гарантируется после проведения сеанса.'
    },
    section9: {
      title: 'Право практикующего',
      content: 'Практикующий оставляет за собой право:',
      item1: 'Отказать или прекратить сеанс, если он сочтет это неуместным.',
      item2: 'Завершить сеанс, если уважительные границы не соблюдаются.'
    },
    section10: {
      title: 'Принятие условий',
      content: 'Отправляя форму заявки и/или бронируя сеанс Рейки, вы подтверждаете, что прочитали, поняли и приняли эти Условия использования.'
    },
    section11: {
      title: 'Информация о конфиденциальности',
      content: 'Мы НЕ собираем личную информацию - для бронирования сеанса требуется только имя (настоящее). Никакая другая информация не требуется.'
    },
    backHome: 'Вернуться на главную'
  },
  German: {
    title: 'Allgemeine Geschäftsbedingungen – Online Reiki-Heilsitzungen',
    intro: 'Durch das Einreichen einer Bewerbung und/oder die Buchung einer Online-Reiki-Heilsitzung bestätigen Sie, dass Sie die folgenden Allgemeinen Geschäftsbedingungen gelesen, verstanden und akzeptiert haben.',
    section1: {
      title: 'Art der Reiki-Heilung',
      content: 'Reiki ist eine ergänzende Energieheilungspraxis, die darauf abzielt, Entspannung, Balance und allgemeines Wohlbefinden zu unterstützen. Reiki-Sitzungen sind kein Ersatz für medizinische Versorgung, psychologische Behandlung oder professionelle Gesundheitsberatung.',
      content2: 'Reiki-Praktizierende diagnostizieren, behandeln, heilen oder verschreiben nicht für medizinische oder psychische Gesundheitszustände.'
    },
    section2: {
      title: 'Kundenverantwortung',
      content: 'Durch die Teilnahme an einer Reiki-Heilsitzung bestätigen Sie, dass:',
      item1: 'Sie die volle Verantwortung für Ihr eigenes körperliches, emotionales, geistiges und spirituelles Wohlbefinden übernehmen.',
      item2: 'Sie verstehen, dass die Ergebnisse von Person zu Person variieren.',
      item3: 'Sie sich einverstanden erklären, angemessene medizinische oder professionelle Hilfe für gesundheitsbezogene Anliegen zu suchen.'
    },
    section3: {
      title: 'Keine medizinischen Ansprüche',
      content: 'Reiki-Heilung ist nicht dazu gedacht, zu ersetzen:',
      item1: 'Medizinische Behandlung',
      item2: 'Psychiatrische oder psychologische Therapie',
      item3: 'Beratung von lizenzierten Gesundheitsfachkräften',
      content2: 'Konsultieren Sie immer einen qualifizierten Gesundheitsdienstleister bezüglich einer medizinischen Erkrankung.'
    },
    section4: {
      title: 'Online / Fernsitzungen',
      content: 'Für Online- oder Fern-Reiki-Sitzungen:',
      item1: 'Sitzungen werden energetisch durchgeführt und erfordern keine körperliche Berührung.',
      item2: 'Ein stabiler Internetzugang und eine ruhige Umgebung werden empfohlen.',
      item3: 'Der Praktizierende ist nicht verantwortlich für technische Probleme, die außerhalb seiner Kontrolle liegen.'
    },
    section5: {
      title: 'Vertraulichkeit',
      content: 'Alle persönlichen Informationen, die während des Bewerbungsprozesses und der Sitzungen geteilt werden, werden als vertraulich behandelt und nicht an Dritte weitergegeben, außer wenn dies gesetzlich vorgeschrieben ist.'
    },
    section6: {
      title: 'Sitzungserfahrung',
      content: 'Kunden können Empfindungen wie Entspannung, Wärme, emotionale Befreiung oder Müdigkeit erleben. Diese Erfahrungen sind normal und variieren individuell. Ein spezifisches Ergebnis wird nicht garantiert.'
    },
    section7: {
      title: 'Einverständnis',
      content: 'Durch die Buchung einer Sitzung bestätigen Sie, dass:',
      item1: 'Sie sich freiwillig für Reiki-Heilung entscheiden.',
      item2: 'Sie eine informierte Zustimmung zur Teilnahme geben.',
      item3: 'Sie die Sitzung jederzeit beenden können.'
    },
    section8: {
      title: 'Zahlungs- und Rückerstattungsrichtlinie',
      content: '',
      item1: 'Die volle Zahlung ist erforderlich, um eine Buchung zu bestätigen (sofern nicht anders angegeben).',
      item2: 'Verpasste Sitzungen oder späte Stornierungen können nicht erstattungsfähig sein.',
      item3: 'Rückerstattungen sind nicht garantiert, sobald eine Sitzung durchgeführt wurde.'
    },
    section9: {
      title: 'Recht des Praktizierenden',
      content: 'Der Praktizierende behält sich das Recht vor:',
      item1: 'Eine Sitzung abzulehnen oder zu beenden, wenn sie als unangemessen erachtet wird.',
      item2: 'Eine Sitzung zu beenden, wenn respektvolle Grenzen nicht eingehalten werden.'
    },
    section10: {
      title: 'Annahme der Bedingungen',
      content: 'Durch das Einreichen des Bewerbungsformulars und/oder die Buchung einer Reiki-Sitzung bestätigen Sie, dass Sie diese Allgemeinen Geschäftsbedingungen gelesen, verstanden und akzeptiert haben.'
    },
    section11: {
      title: 'Datenschutzinformationen',
      content: 'Wir sammeln KEINE persönlichen Informationen - für die Buchung einer Sitzung wird nur der Vorname (echt) benötigt. Keine weiteren Informationen sind erforderlich.'
    },
    backHome: 'Zurück zur Startseite'
  },
  French: {
    title: 'Conditions Générales – Séances de Guérison Reiki en Ligne',
    intro: 'En soumettant une demande et/ou en réservant une séance de guérison Reiki en ligne, vous reconnaissez avoir lu, compris et accepté les Conditions Générales suivantes.',
    section1: {
      title: 'Nature de la Guérison Reiki',
      content: 'Le Reiki est une pratique de guérison énergétique complémentaire destinée à soutenir la relaxation, l\'équilibre et le bien-être général. Les séances Reiki ne sont pas un substitut aux soins médicaux, au traitement psychologique ou aux conseils de santé professionnels.',
      content2: 'Les praticiens Reiki ne diagnostiquent pas, ne traitent pas, ne guérissent pas et ne prescrivent pas pour des conditions médicales ou de santé mentale.'
    },
    section2: {
      title: 'Responsabilité du Client',
      content: 'En participant à une séance de guérison Reiki, vous confirmez que :',
      item1: 'Vous assumez l\'entière responsabilité de votre propre bien-être physique, émotionnel, mental et spirituel.',
      item2: 'Vous comprenez que les résultats varient d\'une personne à l\'autre.',
      item3: 'Vous acceptez de rechercher une aide médicale ou professionnelle appropriée pour toute préoccupation liée à la santé.'
    },
    section3: {
      title: 'Aucune Revendication Médicale',
      content: 'La guérison Reiki n\'est pas destinée à remplacer :',
      item1: 'Le traitement médical',
      item2: 'La thérapie psychiatrique ou psychologique',
      item3: 'Les conseils de professionnels de la santé agréés',
      content2: 'Consultez toujours un professionnel de la santé qualifié concernant toute condition médicale.'
    },
    section4: {
      title: 'Séances en Ligne / à Distance',
      content: 'Pour les séances Reiki en ligne ou à distance :',
      item1: 'Les séances sont menées énergétiquement et ne nécessitent pas de contact physique.',
      item2: 'Un accès Internet stable et un environnement calme sont recommandés.',
      item3: 'Le praticien n\'est pas responsable des problèmes techniques hors de son contrôle.'
    },
    section5: {
      title: 'Confidentialité',
      content: 'Toutes les informations personnelles partagées pendant le processus de demande et les séances sont traitées comme confidentielles et ne seront pas partagées avec des tiers, sauf si la loi l\'exige.'
    },
    section6: {
      title: 'Expérience de la Séance',
      content: 'Les clients peuvent ressentir des sensations telles que la relaxation, la chaleur, la libération émotionnelle ou la fatigue. Ces expériences sont normales et varient individuellement. Aucun résultat spécifique n\'est garanti.'
    },
    section7: {
      title: 'Consentement',
      content: 'En réservant une séance, vous confirmez que :',
      item1: 'Vous choisissez volontairement de recevoir la guérison Reiki.',
      item2: 'Vous donnez un consentement éclairé pour participer.',
      item3: 'Vous pouvez arrêter la séance à tout moment.'
    },
    section8: {
      title: 'Politique de Paiement et de Remboursement',
      content: '',
      item1: 'Le paiement complet est requis pour confirmer une réservation (sauf indication contraire).',
      item2: 'Les séances manquées ou les annulations tardives peuvent ne pas être remboursables.',
      item3: 'Les remboursements ne sont pas garantis une fois qu\'une séance a été fournie.'
    },
    section9: {
      title: 'Droit du Praticien',
      content: 'Le praticien se réserve le droit de :',
      item1: 'Refuser ou interrompre une séance si elle est jugée inappropriée.',
      item2: 'Mettre fin à une séance si les limites respectueuses ne sont pas maintenues.'
    },
    section10: {
      title: 'Acceptation des Conditions',
      content: 'En soumettant le formulaire de demande et/ou en réservant une séance Reiki, vous confirmez avoir lu, compris et accepté ces Conditions Générales.'
    },
    section11: {
      title: 'Informations sur la Confidentialité',
      content: 'Nous NE collectons PAS d\'informations personnelles - pour réserver une séance, seul le prénom (réel) est requis. Aucune autre information n\'est nécessaire.'
    },
    backHome: 'Retour à l\'Accueil'
  }
};
